import {
  ChangeDetectorRef,
  Component,
  ElementRef,
  OnInit,
  ViewChild,
} from '@angular/core';
import { StoreService } from 'src/app/store.service';
import { BY_COUNTRY_SUFFIX, CountryFlagMap, parseCountryMap } from '../../core/store-config-country';
import { forkJoin } from 'rxjs';
import { switchMap } from 'rxjs/operators';
import { FormBuilder, FormGroup } from '@angular/forms';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { environment } from '../../../environments/environment';
import { TranslationService } from 'src/app/core/translation.service';
import { UtilitiesService } from 'src/app/core/utilities.service';
import { ActivatedRoute } from '@angular/router';

import loader from '@monaco-editor/loader';

// Do NOT import from the 'codemirror' meta-package — it ships both CJS and ESM
// builds, causing webpack to create two separate instances of @codemirror/state
// (one per module format). That breaks CodeMirror's instanceof checks at runtime
// in AOT/production builds. Instead, compose basicSetup inline from the same
// @codemirror/* ESM packages used everywhere else in this file.
import { EditorState } from '@codemirror/state';
import {
  EditorView,
  lineNumbers, highlightActiveLineGutter, highlightSpecialChars,
  drawSelection, dropCursor, rectangularSelection, crosshairCursor,
  highlightActiveLine, keymap,
} from '@codemirror/view';
import {
  foldGutter, indentOnInput, syntaxHighlighting,
  defaultHighlightStyle, bracketMatching, foldKeymap,
} from '@codemirror/language';
import { history, defaultKeymap, historyKeymap } from '@codemirror/commands';
// @codemirror/search is intentionally excluded — in CI (npm 6 / Node 12) it ships
// its own nested @codemirror/view, causing KeyBinding type incompatibilities.
// Search (Ctrl+F) is not needed for these script input editors.
import {
  closeBrackets, autocompletion,
  closeBracketsKeymap, completionKeymap,
} from '@codemirror/autocomplete';
import { lintKeymap } from '@codemirror/lint';

const basicSetup = [
  lineNumbers(),
  highlightActiveLineGutter(),
  highlightSpecialChars(),
  history(),
  foldGutter(),
  drawSelection(),
  dropCursor(),
  EditorState.allowMultipleSelections.of(true),
  indentOnInput(),
  syntaxHighlighting(defaultHighlightStyle, { fallback: true }),
  bracketMatching(),
  closeBrackets(),
  autocompletion(),
  rectangularSelection(),
  crosshairCursor(),
  highlightActiveLine(),
  keymap.of([
    ...closeBracketsKeymap,
    ...defaultKeymap,
    ...historyKeymap,
    ...foldKeymap,
    ...completionKeymap,
    ...lintKeymap,
  ]),
];

import { html } from '@codemirror/lang-html';
import {
  javascript,
  javascriptLanguage,
  scopeCompletionSource,
} from '@codemirror/lang-javascript';
import { DEALER_STATUS } from 'src/app/core/constants/data.constant';
import { DataService } from '../../data.service';
import { DealerService } from 'src/app/dealer.service';
import { StoreInfoService } from 'src/app/store-info.service';
import { CdkDragDrop, moveItemInArray } from '@angular/cdk/drag-drop';

declare const $: any;

// Kept below store_config.value's varchar(10240), which the middleware enforces in Config::updateConfig
const SNIPPET_SCRIPT_MAX_LENGTH = 8000;

/**
 * One Facebook pixel as stored in the `facebook_pixel` store config.
 *
 * `capi` names where the pixel's Conversions API token comes from -- never the
 * token itself, which is stored separately and never sent to the browser:
 *   none    browser-only; the pixel fires client-side and nothing else
 *   account the dealer's connected Facebook account
 *   manual  a token entered by hand for this pixel
 */
export interface FacebookPixel {
  pixel_id: string;
  countries: string[];
  capi: 'none' | 'account' | 'manual';
}

@Component({
  selector: 'app-preferences',
  templateUrl: './preferences.component.html',
  styleUrls: ['./preferences.component.scss'],
})
export class PreferencesComponent implements OnInit {
  @ViewChild('codeMirrorEl') codeMirrorEl;
  // The add-pixel dialog template, so a pixel returned from nexus can open it
  // without the operator clicking Add first.
  @ViewChild('pixelDialog', { static: false }) pixelDialogRef;
  @ViewChild('headerScriptRef', { static: false }) headerScriptEl;
  @ViewChild('bodyScriptRef', { static: false }) bodyScriptEl;
  @ViewChild('footerScriptRef', { static: false }) footerScriptEl;
  @ViewChild('headerScriptRef2', { static: false }) headerScriptEl2;
  @ViewChild('bodyScriptRef2', { static: false }) bodyScriptEl2;
  @ViewChild('footerScriptRef2', { static: false }) footerScriptEl2;
  @ViewChild('hicommScriptRef', { static: false }) hicommScriptEl;

  showScriptInstructions = true;

  bearer;
  language: any = [];
  countryList: any = [];
  slideDisabled: any = [];
  inputDisabled: any = [];
  dealers: any = [];
  store: any = [];
  stores: any = [];
  dealer: any = [];
  body = [];
  langChanges: any = {
    default: {},
    status: {},
  };
  countryChanges: any = {
    default: {},
    status: {},
  };
  StoreInfo;
  globalSEOForm: FormGroup;
  customSnippet: FormGroup;
  socialMediaForm: FormGroup;
  messengerForm: FormGroup;
  checkoutPage: FormGroup;
  globalSeo: any = [];

  dealer_id;
  dealer_name;
  feature_list;
  social_media_links;
  city;
  state;
  postal;
  street;
  country;
  social_media;
  twitter;
  website;
  youtube;
  facebook;
  instagram;
  pinterest;
  wechat;
  tiktok;

  store_id;
  store_name;
  store_url;
  subdomain;
  plan_price;
  whatsapp_flag;
  whatsapp_number;
  line_messenger;
  whatsapp_number_thank_you_page;
  page_title;
  caption;
  alt_text;
  filesize;
  store_social_links;
  description;
  keywords;
  customSnippetBase;

  headerScriptValue;
  bodyScriptValue;
  footerScriptValue;

  // Hicomm's embed snippet. Kept out of the Header/Footer Scripts so the
  // storefront can place it in <head> on every page, checkout included.
  hicommScriptValue = '';
  hicommScriptBase = '';
  hicommIsLoading = false;
  hicommScriptView: EditorView;
  edit1 = false;
  edit2 = false;
  edit3 = false;
  edit4 = false;
  edit5 = false;
  edit6 = false;
  edit7 = false;
  analyticsData;
  analyticsForm: FormGroup;

  google_analytics_id;
  tiktok_pixel_id;

  // Facebook pixels: [{ pixel_id, countries }] where countries holds store
  // country_codes or 'GLOBAL'. Stored in the `facebook_pixel` config as a JSON
  // array string; legacy values are a bare pixel id treated as one Global pixel.
  facebookPixels: FacebookPixel[] = [];
  // Maximum Facebook pixels a store may configure.
  readonly maxFacebookPixels = 10;
  // countryList can carry the same country_code more than once (duplicate
  // store_dealer_country rows), which would render the same country as two
  // indistinguishable chips. The pixel dialog iterates this deduped copy so a
  // code appears exactly once. Built when the countries load rather than as a
  // getter, so change detection does not rebuild it on every cycle.
  pixelCountryList: any[] = [];
  // null = the dialog adds a new pixel; an index = it edits that row.
  pixelEditIndex: number | null = null;
  newPixelId = '';
  newPixelCountries: string[] = ['GLOBAL'];
  pixelDialogError = '';
  pixelSaving = false;

  // Conversions API, per pixel. A pixel with a token also sends purchases from
  // our server; a pixel without one only fires in the browser.
  //
  // Tokens are never sent back to the dashboard -- the config endpoint that
  // serves them is public, so it returns a {pixel_id: true} presence map
  // instead. capiTokenSet is that map; the token itself is write-only.
  capiTokenSet: { [pixelId: string]: boolean } = {};
  // 'account' = use the connected Facebook account (resolved server-side at
  // send time), 'manual' = the token typed into the dialog, 'none' = no CAPI.
  newPixelCapiSource: 'none' | 'account' | 'manual' = 'none';
  newPixelCapiToken = '';
  // Whether the pixel being edited already had a token when the dialog opened,
  // so 'manual' can mean "keep what is stored" while the input sits empty.
  newPixelHadToken = false;
  // Whether the pixel being edited was set up through a connected Facebook
  // account. Captured at open time, because the save path re-resolves the
  // source and would overwrite it. Only matters while capiConnectEnabled is
  // false: that pixel cannot be edited back into the account path, so step 2
  // says so instead of quietly downgrading it to browser-only.
  newPixelWasAccountSourced = false;

  // The id this pixel had when the edit dialog opened, so a change can be
  // detected on save. Tokens are stored keyed by pixel id, so renaming a
  // pixel has to move the token with it -- and we cannot, because the stored
  // token is never sent to the dashboard. The old id's token is cleared
  // instead, and a manual pixel needs its token pasted again. '' while adding.
  pixelOriginalId = '';

  // --- Add-pixel wizard --------------------------------------------------
  // 1: what kind of setup (browser-only pixel, or pixel + Conversions API)
  // 2: the pixel itself -- a text input, or the CAPI tabs
  // 3: which storefronts it runs on
  //
  // Editing an existing pixel jumps straight to step 3: its id and source are
  // already settled, and re-running the earlier steps would mean re-fetching
  // pixels just to change a country.
  pixelStep: 1 | 2 | 3 = 1;
  // Which kind of setup was chosen on step 1. null until they pick, so the
  // Next button can stay disabled rather than defaulting them into one.
  // Defaults to 'capi', and the CAPI option is listed first on step 1: it is
  // the setup we want dealers on, and a browser-only pixel loses exactly the
  // conversions the Conversions API exists to recover. Null would mean the
  // dialog opens with nothing chosen and Next disabled, which reads as a
  // question rather than a recommendation.
  pixelSetupKind: 'pixel' | 'capi' | null = 'capi';
  // The Facebook-connected path is off for now: a dealer either pastes an
  // access token or runs the pixel browser-only. Everything behind it is still
  // here -- the nexus fetch, the picker, the create-a-pixel form and the SSO
  // return -- so turning this back to true restores the flow as it was.
  readonly capiConnectEnabled: boolean = false;
  // Step 2, CAPI only: 'connect' = choose from the pixels on the dealer's
  // Facebook account, 'manual' = type the pixel id and paste a token. Manual
  // is the only path while capiConnectEnabled is false.
  pixelEntryMode: 'connect' | 'manual' = 'manual';

  // Pixels and ad accounts fetched from nexus.
  nexusPixels: { pixel_id: string; name: string; account_id: string; account_name: string }[] = [];
  nexusAdAccounts: { account_id: string; name: string }[] = [];
  nexusLoading = false;
  // Set when the dealer has no usable Facebook connection. Carries the reason
  // and the SSO link that re-starts authorisation.
  nexusError = '';
  nexusSsoLink = '';
  // Manual CAPI: the pixel id + token pair is checked against Meta before it
  // can be saved, because a token generated for a DIFFERENT pixel saves fine
  // and then fails silently at the first real purchase.
  //   idle     nothing to check yet (a field is empty)
  //   checking request in flight
  //   valid    Meta confirmed the pair
  //   invalid  Meta rejected it -- tokenCheckError says why
  //   unknown  Meta could not be reached; saving is still allowed
  tokenCheckState: 'idle' | 'checking' | 'valid' | 'invalid' | 'unknown' = 'idle';
  tokenCheckError = '';
  // The pair the current state refers to, so an edit to either field
  // invalidates the result instead of leaving a stale tick on screen.
  private tokenCheckedPair = '';

  // True just after returning from a successful nexus connect, so the pixel
  // section can show that CAPI is now available.
  capiJustConnected = false;
  // The pixel the dealer picked in nexus, ready to be added here.
  capiReturnedPixelId = '';

  // Creating a brand-new pixel from inside the picker.
  creatingPixel = false;
  newPixelName = '';
  newPixelAccountId = '';
  showCreatePixel = false;

  closeResult = '';
  success = 'success';

  showloader1 = false;
  showloader2 = false;
  showloader3 = false;
  snippetIsLoading = false;
  storeSubdomain = environment.storeSubdomain;

  status;
  errorMsg;

  // Media Editor variables for product photo
  favIcoImgURL;
  favIcoPhotoId;
  ogimgURL;
  ogImgPhotoId;

  // Store Logo — the logo the storefront renders in the header and footer.
  // It lives in the theme's custom content (store_logo_url / _width / _height),
  // the same record the Site Editor used to write, so saving here reaches the
  // storefront through the existing custom_content path with no changes there.
  storeLogoUrl = '';
  storeLogoMediaId;
  storeLogoWidth;
  storeLogoHeight;
  storeLogoIsLoading = false;
  storeLogoIsSaving = false;

  // Custom content is stored per language, so the card loads one language at a
  // time. The toggle keeps the usual case — one logo for the whole store — a
  // single click, while still allowing a language to be given its own logo.
  storeLogoLanguageCode = '';
  storeLogoLanguageName = '';
  storeLogoApplyAllLanguages = true;

  // Matches the fallbacks the storefront's HeaderSection/FooterSection render
  // when custom content carries no size, so an unset store looks the same here.
  private readonly STORE_LOGO_DEFAULT_WIDTH = 140;
  private readonly STORE_LOGO_DEFAULT_HEIGHT = 41;

  showCountrySelector = 0;
  showLanguageSelector = 0;
  showNonCodSelector = 0;
  showCodSelector = 0;
  showSelfCollectSelector = 0;
  showInstallmentSelector = 0;
  showSubscriptionSelector = 0;
  isShowCountrySetting = false;
  isShowLanguageSetting = false;
  dashboardLanguages = {};
  dashboardLanguageCode = '';
  emailLanguageCode = '';
  selectedLanguageCode = '';
  selectedEmailLanguageCode = '';
  emailLanguageIsSaving = false;
  totalCredit;
  featurePlan;
  autoApproveCod = 0;
  autoApproveCollect = 0;
  // Per-country overrides of the two auto-approve flags, keyed by config
  // name then store country code (`<name>_by_country` rows, JSON maps). A
  // country without an entry falls back to the store-wide flag above.
  autoApproveByCountry: { [name: string]: CountryFlagMap } = {};
  // Same for the payment-method Enabled switches, keyed by payment type.
  paymentEnabledByCountry: { [type: string]: CountryFlagMap } = {};
  readonly paymentToggleTypes = ['non_cod', 'cod', 'self_collect', 'installment', 'subscription'];

  emailLanguages = {
    'en-US': 'English',
    'ms-MY': 'Bahasa Malaysia',
    'zh-CN': '\u7B80\u4F53\u4E2D\u6587',
    'zh-TW': '\u7E41\u9AD4\u4E2D\u6587',
  };
  selectedSeoLanguageCode = '';
  language_name;
  errorStatus = false;
  isCheckoutStepsChanged = false;
  isCheckoutStepsSingle = 0;
  isCheckoutStepsLoading = false;

  // Checkout theme (Appearance > Checkout). Persisted as the generic store
  // config `checkout_theme`, which the storefront reads straight off
  // storeInfo.store_configs. Payment button colour is deliberately not here —
  // it is set per link when creating an express checkout.
  //
  // `checkoutThemeLoaded` and `countryLoaded` gate the card: the theme picker
  // is hidden for Taiwan stores, and both values arrive from separate async
  // calls, so rendering before they land flashes the wrong state.
  checkoutTheme = 'classic';
  checkoutThemeSaved = 'classic';
  checkoutThemeLoaded = false;
  countryLoaded = false;
  isCheckoutThemeLoading = false;
  checkoutThemeOptions = [
    {
      value: 'classic',
      title: 'Classic',
      description:
        'The current checkout layout, with the order summary beside the form.',
      preview: 'assets/checkout-theme-classic.svg',
    },
    {
      value: 'split',
      title: 'Split',
      description:
        'Two-column checkout: form on the left, a full-height order summary on the right.',
      preview: 'assets/checkout-theme-split.svg',
    },
  ];
  selectedTab = 'Regional Settings';
  regionalActiveTab = 'languages';
  paymentMethod;
  enableAIAssistant = false;
  isDisableSave = false;

  courierSectionExpandedMap: { [type: string]: boolean } = {};
  courierChangedMap: { [type: string]: boolean } = {};
  courierIsSavingMap: { [type: string]: boolean } = {};
  // Payments tab: the store country whose courier lists are shown. Starts on
  // the Regional Settings default country and follows the country selector.
  paymentCountryCode = '';
  paymentCountryList: any[] = [];

  public collapseStates = {
    general: true,
    selling: true,
    appearance: true,
    metaBranding: true,
    customerExperience: true,
  };

  public isLoadingIconSaving = false;

  buildForm() {
    this.analyticsForm = this.formBuilder.group({
      store_id: [''],
      name: [''],
      config: [''],
      google_analytics_id: '',
      tiktok_pixel_id: '',
    });
    this.globalSEOForm = this.formBuilder.group({
      sitename: '',
      description: [''],
      keywords: [''],
      page_title: [''],
    });
    this.socialMediaForm = this.formBuilder.group({
      twitter: [''],
      website: [''],
      youtube: [''],
      facebook: [''],
      instagram: [''],
      wechat: [''],
      tiktok: [''],
    });
    this.customSnippet = this.formBuilder.group({
      headerScriptValue: [''],
      bodyScriptValue: [''],
      footerScriptValue: [''],
    });
    this.messengerForm = this.formBuilder.group({
      whatsapp_flag: [''],
      whatsapp_number: [''],
      line_messenger: [''],
    });
    this.checkoutPage = this.formBuilder.group({
      whatsapp_number_thank_you_page: [''],
    });
  }
  dealer$ = this.dealerService.getDealer();
  storeInfo$ = this.storeInfoService.getStoreInfos();
  testimonialToggle = true;
  testimonialGet = "";
  isCompanyStore = false;
  loadingIconGet = "default";
  loadingIconLabel = ['default','afyaa','estore1','estore2','estore3'];
  loadingIconLabelSelected = 'default';
  defaultCountry = "";

  constructor(
    private changeDetectorRef: ChangeDetectorRef,
    private svc: StoreService,
    private modalService: NgbModal,
    private formBuilder: FormBuilder,
    private utilitiesService: UtilitiesService,
    public translationSvc: TranslationService,
    private utils: UtilitiesService,
    private dataService: DataService,
    private dealerService: DealerService,
    private storeInfoService: StoreInfoService,
    private route: ActivatedRoute
  ) {
    this.buildForm();

    // this.headerScriptValue.bind(this);
    // this.bodyScriptValue.bind(this);
    // this.footerScriptValue.bind(this);
  }

  get snippetIsChanged() {
    return this.customSnippetBase != JSON.stringify(this.customSnippet.value);
  }

  readonly snippetMaxLength = SNIPPET_SCRIPT_MAX_LENGTH;
  private snippetLengthCache = { payload: '', length: 0 };

  // The snippetScript value exactly as it is saved
  get snippetPayload(): string {
    return JSON.stringify({
      headerScript: this.customSnippet.value['headerScriptValue'],
      bodyScript: this.customSnippet.value['bodyScriptValue'],
      footerScript: this.customSnippet.value['footerScriptValue'],
    });
  }

  // store_config.value holds at most 10240 characters; anything longer used to be cut silently, leaving
  // invalid JSON that blanked the editor and stopped every header script on the storefront.
  // Count code points, as MySQL does, and include the JSON wrapper since that is what gets stored.
  // Cached because the template reads it on every change detection pass.
  get snippetLength(): number {
    const payload = this.snippetPayload;
    if (payload !== this.snippetLengthCache.payload) {
      this.snippetLengthCache = { payload, length: Array.from(payload).length };
    }
    return this.snippetLengthCache.length;
  }

  get snippetIsTooLong(): boolean {
    return this.snippetLength > SNIPPET_SCRIPT_MAX_LENGTH;
  }

  // Amber from 90% of the limit, so dealers see it coming before Save is blocked
  get snippetIsNearLimit(): boolean {
    return !this.snippetIsTooLong && this.snippetLength >= SNIPPET_SCRIPT_MAX_LENGTH * 0.9;
  }

  scriptLength(controlName: string): number {
    return Array.from(this.customSnippet.value[controlName] ?? '').length;
  }

  saveSnippet() {
    let configName = 'snippetScript';
    let message = 'Snippet Script';
    let payload = this.snippetPayload;

    const payloadLength = this.snippetLength;
    if (payloadLength > SNIPPET_SCRIPT_MAX_LENGTH) {
      this.utils.notify.showError(
        this.utils.translate(
          'Your scripts are too long to save ({0} characters). The header, body and footer scripts together can be at most {1} characters. Please shorten them and try again.',
          [payloadLength.toLocaleString(), SNIPPET_SCRIPT_MAX_LENGTH.toLocaleString()]
        ),
        message
      );
      return;
    }

    let me = this,
      body = {
        store_id: me.store.store_id,
        name: configName,
        value: payload,
      };

    this.snippetIsLoading = true;
    me.svc.updateConfig(me.bearer, body).subscribe(
      (res) => {
        me.getAllStoreConfig();
        this.utils.notify.showSuccess(
          this.utils.translate('Updated Successfully!'),
          message
        );
        this.snippetIsLoading = false;
      },
      (error) => {
        // Show the server's reason (e.g. the length limit) rather than a bare "Update failed!"
        const serverMessage = error?.error?.data?.value;
        this.utils.notify.showError(
          typeof serverMessage === 'string' ? serverMessage : this.utils.translate('Update failed!'),
          message
        );
        this.snippetIsLoading = false;
      }
    );
  }

  get hicommIsChanged() {
    return this.hicommScriptValue !== this.hicommScriptBase;
  }

  saveHicommScript() {
    const message = 'Hicomm';
    const script = this.hicommScriptValue;
    const body = {
      store_id: this.store.store_id,
      name: 'hicomm_script',
      // config/update rejects an empty value; '0' is the storefront's "unset".
      value: script.trim() === '' ? '0' : script,
    };

    this.hicommIsLoading = true;
    this.svc.updateConfig(this.bearer, body).subscribe(
      () => {
        this.hicommScriptBase = script;
        this.getAllStoreConfig();
        this.utils.notify.showSuccess(
          this.utils.translate('Updated Successfully!'),
          message
        );
        this.hicommIsLoading = false;
      },
      () => {
        this.utils.notify.showError(
          this.utils.translate('Update failed!'),
          message
        );
        this.hicommIsLoading = false;
      }
    );
  }

  ngOnInit(): void {
    this.toggleOpen('general');
    this.handleCapiReturn();
    const me = this;
    me.bearer = localStorage.getItem('bearer');
    me.store_id = localStorage.getItem('store_id');
    this.dashboardLanguages = this.translationSvc.getAvailableLanguage();
    this.dashboardLanguageCode = this.translationSvc.getLanguageCode();
    const info = JSON.parse(localStorage.getItem('5s-info'));
    const dealerSubs = localStorage.getItem('dealer_subs');

    this.route.queryParams.subscribe((params) => {
      if (params && params['tab']) {
        this.selectTab(params['tab']);
        if (['Profile', 'Regional Settings', 'Email Language'].includes(params['tab'])) {
          this.collapseStates.general = false;
        }
      }
    });

    Promise.resolve()
      .then(() => {
        return me.getStoreInfo();
      })
      .then(() => {
        me.getDealerInfo(me.store_id);
        me.getDealerPlan(info.d_id);
        me.getStoreLanguage();
        me.getStoreCountry();
        me.getAllStoreConfig();
        me.getPaymentMethod();
        me.getDealerCredit(info.d_id);

        if (
          this.featurePlan.includes('ai-assistant') ||
          dealerSubs === 'false'
        ) {
          this.enableAIAssistant = true;
        }

        return new Promise((resolve, reject) => {
          resolve(true);
        });
      })
      .catch((err) => {});
  }

  getDealerPlan(dealerId) {
    if (this.dataService.getDealerPlan() === null) {
      this.svc.getDealerPlan(this.bearer, dealerId).subscribe((res) => {
        this.featurePlan = res['data']['feature_list'];
        this.dataService.updateDealerPlan(res['data']);
        this.dataService.updateDealerSubStatus(
          res['data']['dealer_subscription_status']
        );

        if (
          res['data']['feature_list'].includes('ai-assistant') ||
          this.dataService.getDealerSubStatus() === false
        ) {
          this.enableAIAssistant = true;
        }
      });
    } else {
      const dealerPlan = this.dataService.getDealerPlan();
      this.featurePlan = dealerPlan.feature_list;

      if (
        this.featurePlan.includes('ai-assistant') ||
        this.dataService.getDealerSubStatus() === false
      ) {
        this.enableAIAssistant = true;
      }
    }
  }

  getDealerCredit(dealerId) {
    this.svc.getDealerCredit(this.bearer, dealerId).subscribe(
      (res: any) => {
        this.enableAIAssistant =
          res.data.totalCredit >= res.data.minimumCredit &&
          res.data?.is_valid === true;
      },
      (error) => {
        const errorMsg = this.utils.getErrorMessageWithRefId(
          error,
          'Unknown error, kindly contact our eStore team to check'
        );
        this.utils.notify.showError(errorMsg, 'Error!');
      }
    );
  }

  ngAfterViewInit() {
    // this.initCodemirror();
  }

  headerMonacoEditor;
  bodyMonacoEditor;
  footerMonacoEditor;
  initMonacoEditor() {
    let headerScriptElement = this.headerScriptEl2?.nativeElement;
    let bodyScriptElement = this.bodyScriptEl2?.nativeElement;
    let footerScriptElement = this.footerScriptEl2?.nativeElement;

    loader.init().then((monaco) => {
      const editor = (this.headerMonacoEditor = monaco.editor.create(
        headerScriptElement,
        {
          value: this.headerScriptValue,
          language: 'html',
          theme: 'monokai',
        }
      ));

      this.bodyMonacoEditor = monaco.editor.create(bodyScriptElement, {
        value: this.bodyScriptValue,
        language: 'html',
        theme: 'monokai',
      });

      this.footerMonacoEditor = monaco.editor.create(footerScriptElement, {
        value: this.footerScriptValue,
        language: 'html',
        theme: 'monokai',
      });
    });
  }

  // One HTML editor state, shared by the Header/Footer Scripts and Hicomm
  // tabs. Each editor gets its own, so a single failure won't break the others.
  private makeScriptEditorState(doc: string, onUpdate: (doc: string) => void): EditorState {
    // Null-guard cleanWindow — undefined throws in AOT builds
    const extraExtensions = (window as any).cleanWindow
      ? [javascriptLanguage.data.of({
          autocomplete: scopeCompletionSource((window as any).cleanWindow),
        })]
      : [];

    return EditorState.create({
      doc,
      extensions: [
        basicSetup,
        html(),
        EditorView.lineWrapping,
        ...extraExtensions,
        EditorView.updateListener.of((e) => {
          if (e.docChanged) {
            const newDoc = e.state.doc.toString();
            onUpdate(newDoc);
            // CodeMirror fires outside Angular's zone — trigger CD so
            // snippetIsChanged / hicommIsChanged re-evaluate and Save enables.
            this.changeDetectorRef.detectChanges();
          }
        }),
      ],
    });
  }

  initHicommEditor() {
    const hicommScriptElement = this.hicommScriptEl?.nativeElement;
    // Not on the Hicomm tab — nothing to mount
    if (!hicommScriptElement) return;

    this.hicommScriptView?.destroy();
    try {
      this.hicommScriptView = new EditorView({
        state: this.makeScriptEditorState(this.hicommScriptValue ?? '', (doc) => {
          this.hicommScriptValue = doc;
        }),
        parent: hicommScriptElement,
      });
    } catch (e) {
      console.error('ERROR hicomm EditorState', e);
    }
  }

  headerScriptView: EditorView;
  bodyScriptView: EditorView;
  footerScriptView: EditorView;
  headerScriptState!: EditorState;
  bodyScriptState!: EditorState;
  footerScriptState!: EditorState;
  initCodemirror() {
    let headerScriptElement = this.headerScriptEl?.nativeElement;
    let bodyScriptElement = this.bodyScriptEl?.nativeElement;
    let footerScriptElement = this.footerScriptEl?.nativeElement;

    // Not on the script tab — nothing to mount
    if (!headerScriptElement) return;

    // Destroy previous instances to avoid duplicate editors on re-entry
    this.headerScriptView?.destroy();
    this.bodyScriptView?.destroy();
    this.footerScriptView?.destroy();

    const makeState = this.makeScriptEditorState.bind(this);

    try {
      this.headerScriptState = makeState(this.headerScriptValue ?? '', (doc) => {
        this.headerScriptValue = doc;
        this.customSnippet.controls['headerScriptValue'].setValue(doc);
      });
      this.headerScriptView = new EditorView({
        state: this.headerScriptState,
        parent: headerScriptElement,
      });
    } catch (e) {
      console.error('ERROR header EditorState', e);
    }

    try {
      this.bodyScriptState = makeState(this.bodyScriptValue ?? '', (doc) => {
        this.bodyScriptValue = doc;
        this.customSnippet.controls['bodyScriptValue'].setValue(doc);
      });
      this.bodyScriptView = new EditorView({
        state: this.bodyScriptState,
        parent: bodyScriptElement,
      });
    } catch (e) {
      console.error('ERROR body EditorState', e);
    }

    try {
      this.footerScriptState = makeState(this.footerScriptValue ?? '', (doc) => {
        this.footerScriptValue = doc;
        this.customSnippet.controls['footerScriptValue'].setValue(doc);
      });
      this.footerScriptView = new EditorView({
        state: this.footerScriptState,
        parent: footerScriptElement,
      });
    } catch (e) {
      console.error('ERROR footer EditorState', e);
    }
  }

  onTabChanged(event) {
    console.log('onTabChanged', { event });
  }

  emailLanguageCodeChanged(event) {
    this.selectedEmailLanguageCode = event?.target?.value;
  }

  saveEmailLanguage(event) {
    this.emailLanguageIsSaving = true;
    this.svc
      .updateDealerConfig(this.bearer, {
        dealer_id: this.dealer_id,
        name: 'email_language',
        value: this.selectedEmailLanguageCode,
      })
      .subscribe(
        (res) => {
          this.getAllDealerConfig();
          this.utils.notify.showSuccess(
            this.utils.translate('Updated Successfully!')
          );
          this.emailLanguageIsSaving = false;
        },
        (error) => {
          this.utils.notify.showError(this.utils.translate('Update failed!'));
          this.emailLanguageIsSaving = false;
        }
      );
  }

  getStoreLanguage() {
    let me = this;
    me.svc.getStoreLanguage(me.bearer, me.store_id).subscribe((res) => {
      me.language = res['data'];

      const defaultLanguage =
        me.language.find((lang) => +lang.default) ?? me.language[0];

      this.selectedSeoLanguageCode = defaultLanguage['language_code'];
      this.language_name = defaultLanguage['language_name'];
      this.updateSeoForm();

      if (res['data'].length > 0) {
        res['data'].forEach((value) => {
          me.inputDisabled[value.language_code] = value.status != '1';
          me.slideDisabled[value.language_code] = value.default == '1';
        });
      }
    });
  }

  getStoreCountry() {
    let me = this;
    me.svc.getStoreCountry(me.bearer, me.store_id).subscribe((res) => {
      me.countryList = res['data'];

      if (res['data'].length > 0) {
        res['data'].forEach((value) => {
          // Keep the unstripped name for the pixel dialog. The strip below
          // drops everything before the last '-', which turns the origin-
          // destination naming into just the destination ("Hong Kong-Macau"
          // becomes "Macau"), losing which storefront the code belongs to.
          // Other screens have always used the stripped form, so that stays.
          value.country_name_full = (value.country_name || '').trim();
          value.country_name = value.country_name.split('-').pop().trim();
          me.inputDisabled[value.country_code] = value.status != '1';
          me.slideDisabled[value.country_code] = value.default == '1';
          if(value.default == '1'){
          me.defaultCountry =  value.country_name;
          }
        });
      }

      me.pixelCountryList = me.buildPixelCountryList(me.countryList);
      me.paymentCountryList = me.buildPaymentCountryList(me.countryList);
      me.syncPaymentCountrySelection();

      me.countryLoaded = true;
    });
  }

  // Taiwan keeps the classic checkout: its single-page flow (mandatory email,
  // payment inside the summary column, local e-invoice fields) has no split
  // equivalent. The storefront enforces this too — see EStoreCheckoutTheme.js.
  get isTaiwanStore(): boolean {
    return this.defaultCountry?.toLowerCase() === 'taiwan';
  }

  get showCheckoutThemeCard(): boolean {
    return this.countryLoaded && this.checkoutThemeLoaded && !this.isTaiwanStore;
  }

  get isCheckoutThemeChanged(): boolean {
    return this.checkoutTheme !== this.checkoutThemeSaved;
  }

  selectCheckoutTheme(theme: string): void {
    this.checkoutTheme = theme;
  }

  /**
   * Saves the theme and its button colour. Both go through the generic
   * store-config endpoint, so no backend change is involved — the storefront
   * picks them up from storeInfo.store_configs on the next page load.
   *
   * The colour is only meaningful to the split theme, but it is saved either
   * way so switching back and forth doesn't lose the dealer's choice.
   */
  saveCheckoutTheme(): void {
    this.isCheckoutThemeLoading = true;

    const theme = this.checkoutTheme;

    this.svc
      .updateConfig(this.bearer, {
        name: 'checkout_theme',
        store_id: this.store_id,
        value: theme,
      })
      .subscribe(
        () => {
          this.isCheckoutThemeLoading = false;
          this.checkoutThemeSaved = theme;
          this.utils.notify.showSuccess(
            this.utils.translate('Checkout Theme Updated Successfully!')
          );
        },
        () => {
          this.isCheckoutThemeLoading = false;
          this.utils.notify.showError(
            this.utils.translate('Failed to Update Checkout Theme')
          );
        }
      );
  }

  getPaymentMethod() {
    this.svc.getPaymentMethod(this.bearer, this.store_id).subscribe((res) => {
      this.paymentMethod = res['data'];
      // Set initial checkbox state per courier:
      // - if status field exists and is not null, derive from it (0/false → unticked)
      // - otherwise default to enabled
      (this.paymentMethod ?? []).forEach((method: any) => {
        (method.courier_options ?? []).forEach((courier: any) => {
          if (courier.status !== undefined && courier.status !== null) {
            courier.enabled = courier.status !== 0 && courier.status !== '0' && courier.status !== false;
          } else {
            courier.enabled = true;
          }
        });
      });
      // Sync installment couriers to match non_cod on initial load
      this.syncCouriersToInstallment();
      this.ensureCourierSelection();
    });
  }

  // Store-wide value of a payment method's Enabled switch.
  storeWidePaymentEnabled(type: string): boolean {
    const selectors = {
      'cod': this.showCodSelector,
      'self_collect': this.showSelfCollectSelector,
      'installment': this.showInstallmentSelector,
      'non_cod': this.showNonCodSelector
    };
    return selectors[type] === 1;
  }

  // Enabled switch for the country picked in the Payments country selector:
  // that country's override when it has one, else the store-wide value.
  getDealerPaymentMethod(type): boolean {
    const override = this.paymentEnabledByCountry[type]?.[this.paymentCountryCode];
    if (override !== undefined) {
      return Number(override) === 1;
    }
    return this.storeWidePaymentEnabled(type);
  }

  autoApproveConfigName(type: string): string | null {
    switch (type) {
      case 'cod':
        return 'auto_approve_cod';
      case 'self_collect':
        return 'auto_approve_collect';
      default:
        return null;
    }
  }

  // Auto-approve for the country picked in the Payments country selector:
  // that country's override when it has one, else the store-wide flag.
  getAutoApproveStatus(type): boolean {
    const name = this.autoApproveConfigName(type);
    if (!name) return false;

    const override = this.autoApproveByCountry[name]?.[this.paymentCountryCode];
    if (override !== undefined) {
      return Number(override) === 1;
    }
    return (name === 'auto_approve_cod' ? this.autoApproveCod : this.autoApproveCollect) === 1;
  }

  // Writes one country's value into a `<name>_by_country` map, leaving the
  // store-wide row as the fallback for countries never set explicitly.
  updateCountryConfig(name: string, current: CountryFlagMap, message: string, status: number) {
    const map = { ...(current ?? {}), [this.paymentCountryCode]: status };
    this.updateDealerConfig(name + BY_COUNTRY_SUFFIX, message, JSON.stringify(map));
  }

  getStoreInfo() {
    let me = this;
    return new Promise((resolve, reject) => {
      this.storeInfo$.subscribe(
        (res) => {
          me.store = res;
          this.subdomain = res.subdomain;
          this.store_name = res.store_name;
          resolve(true);
        },
        (error) => reject(error)
      );
    });
  }

  getDealerInfo(store_id) {
    if (this.dashboardLanguageCode === null) {
      this.dashboardLanguageCode = 'en-US';
    }
    this.dealer$.subscribe((res) => {
      this.dealer = Object.values(res);
      this.dealer_id = res.dealer_id;
      this.getAllDealerConfig();
    });
    this.storeInfo$.subscribe(
      (res) => {
        this.StoreInfo = res;
        this.store_name = res?.store_name;
        this.store_url = res?.store_url;
        let store_social_link = res?.store_social_link
          ? JSON.parse(res?.store_social_link)
          : {};
        this.store_id = res?.store_id;
        this.messengerForm.value['whatsapp_number'] = this.whatsapp_number;
        this.messengerForm.controls['whatsapp_number'].setValue(
          this.whatsapp_number
        );
        this.whatsapp_flag = store_social_link?.whatsapp_flag;
        this.whatsapp_number = store_social_link?.whatsapp_number;
        this.isCompanyStore = this.StoreInfo?.config?.is_company_store;
      }
    );
    this.messengerForm = this.formBuilder.group({
      whatsapp_flag: [this.whatsapp_flag],
      whatsapp_number: [this.whatsapp_number],
      line_messenger: [this.line_messenger],
    });
    this.svc
      .getGlobalSEO(this.bearer, store_id, this.dashboardLanguageCode)
      .subscribe((res) => {
        this.globalSeo = res['data'];
        this.description =
          this.globalSeo[this.selectedSeoLanguageCode]?.description;
        this.page_title =
          this.globalSeo[this.selectedSeoLanguageCode]?.page_title;
        this.keywords = this.globalSeo[this.selectedSeoLanguageCode]?.keywords;
        this.globalSEOForm.value['description'] = this.description;
        this.globalSEOForm.value['page_title'] = this.page_title;
        this.globalSEOForm.value['keywords'] = this.keywords;
        this.globalSEOForm = this.formBuilder.group({
          description: [this.description],
          keywords: [this.keywords],
          page_title: [this.page_title],
        });
        // this.globalSEOForm.controls['description'].setValue(this.description);
        // this.globalSEOForm.controls['page_title'].setValue(this.page_title);
        // this.globalSEOForm.controls['keywords'].setValue(this.keywords);
      });
  }

  checkSocialMedia() {
    if (this.socialMediaForm.value['twitter'] === 'https://twitter.com/') {
      this.socialMediaForm.value['twitter'] = '';
    }
    if (this.socialMediaForm.value['website'] === 'https://') {
      this.socialMediaForm.value['website'] = '';
    }
    if (this.socialMediaForm.value['youtube'] === 'https://www.youtube.com/') {
      this.socialMediaForm.value['youtube'] = '';
    }
    if (
      this.socialMediaForm.value['facebook'] === 'https://www.facebook.com/'
    ) {
      this.socialMediaForm.value['facebook'] = '';
    }
    if (
      this.socialMediaForm.value['instagram'] === 'https://www.instagram.com/'
    ) {
      this.socialMediaForm.value['instagram'] = '';
    }
    if (this.socialMediaForm.value['wechat'] === 'https://') {
      this.socialMediaForm.value['wechat'] = '';
    }
    if (this.socialMediaForm.value['tiktok'] === 'https://tiktok.com/@') {
      this.socialMediaForm.value['tiktok'] = '';
    }
  }

  updateSocialMedia(form: number) {
    this.showloader2 = true;
    this.checkSocialMedia();
    let configName = 'social_media';
    let payloadJson = {
      twitter: this.socialMediaForm.value['twitter'],
      website: this.socialMediaForm.value['website'],
      youtube: this.socialMediaForm.value['youtube'],
      facebook: this.socialMediaForm.value['facebook'],
      instagram: this.socialMediaForm.value['instagram'],
      wechat: this.socialMediaForm.value['wechat'],
      tiktok: this.socialMediaForm.value['tiktok'],
    };
    let payload = JSON.stringify(payloadJson);
    let body = {
      store_id: this.store.store_id,
      name: configName,
      value: payload,
    };
    this.updateConfig(form, body);
    this.showloader2 = false;
  }
  updateConfig(type, body) {
    this.svc.updateConfig(this.bearer, body).subscribe(
      (res) => {
        this.editForm(type, false);
        this.getAllStoreConfig();
        this.utils.notify.showSuccess(
          this.utils.translate('Updated Successfully!')
        );
      },
      (error) => {
        this.utils.notify.showError(this.utils.translate('Update Failed!'));
      }
    );
  }

  updateMessenger(type) {
    let social_data;
    let body;
    if (this.messengerForm.value['whatsapp_number'] === null) {
      social_data = {
        whatsapp_flag: this.messengerForm.value['whatsapp_number'] !== null,
        whatsapp_number: this.messengerForm.value['whatsapp_number'],
      };
    } else {
      this.checkPhoneNumber();
      social_data = {
        whatsapp_flag: true,
        whatsapp_number: this.messengerForm.value['whatsapp_number'],
      };
    }
    if (
      this.messengerForm.value['line_messenger'] ||
      this.messengerForm.value['line_messenger'] === ''
    ) {
      if (this.checkLine()) {
        body = {
          store_id: this.store.store_id,
          name: 'line_messenger',
          value:
            this.messengerForm.value['line_messenger'] === ''
              ? 0
              : this.messengerForm.value['line_messenger'],
        };
        this.updateConfig(type, body);
      } else {
        this.edit6 = true;
        this.errorStatus = true;
        setTimeout(() => {
          if (this.errorStatus) {
            this.errorStatus = false;
          }
        }, 3000);
        return;
      }
    }
    this.store_social_links = JSON.stringify(social_data);
    this.updateWhatsapp(type);
    this.edit6 = false;
  }

  updateCheckoutContact() {
    const body = {
      store_id: this.store.store_id,
      name: 'whatsapp_number_thank_you_page',
      value: this.checkoutPage.value['whatsapp_number_thank_you_page'],
    };
    this.showloader3 = true;
    this.svc.updateConfig(this.bearer, body).subscribe(
      () => {
        this.showloader3 = false;
        this.whatsapp_number_thank_you_page = this.checkoutPage.value['whatsapp_number_thank_you_page'];
        this.editForm(7, false);
        this.utils.notify.showSuccess(this.utils.translate('Updated Successfully!'));
      },
      () => {
        this.showloader3 = false;
        this.utils.notify.showError(this.utils.translate('Update Failed!'));
      }
    );
  }

  clearCheckoutWhatsapp() {
    const body = {
      store_id: this.store.store_id,
      name: 'whatsapp_number_thank_you_page',
      value: this.checkoutPage.value['whatsapp_number_thank_you_page'],
      status: 0,
    };
    this.showloader3 = true;
    this.svc.updateConfig(this.bearer, body).subscribe(
      () => {
        this.showloader3 = false;
        this.whatsapp_number_thank_you_page = '';
        this.checkoutPage.controls['whatsapp_number_thank_you_page'].setValue('');
        this.utils.notify.showSuccess(this.utils.translate('Updated Successfully!'));
      },
      () => {
        this.showloader3 = false;
        this.utils.notify.showError(this.utils.translate('Update Failed!'));
      }
    );
  }

  updateWhatsapp(form: number) {
    const store_id = localStorage.getItem('store_id');
    this.svc
      .updateWhatsapp(store_id, this.store_social_links, this.bearer)
      .subscribe(
        (data) => {
          console.log('whatsapp data', data);
          this.getWhatsappStoreConfig();
          this.showloader3 = true;
          this.editForm(6, false);
          // this.getDealerInfo(this.store_id);

          setTimeout(() => {
            this.utils.notify.showSuccess(
              this.utils.translate('Updated Successfully!')
            );
            let me = this;
            this.storeInfo$.subscribe(
                (res) => {
                  let store_social_link = res?.store_social_link
                  ? JSON.parse(res?.store_social_link)
                  : {};
                me.whatsapp_flag = store_social_link?.whatsapp_flag;
                me.whatsapp_number = store_social_link?.whatsapp_number;
                me.messengerForm.value['whatsapp_number'] = me.whatsapp_number;
                me.messengerForm.controls['whatsapp_number'].setValue(
                  me.whatsapp_number
                );
                }
              );
            this.showloader3 = false;
          }, 2000);
        },
        (error) => {
          this.errorMsg = error['error']['message'];
          this.utils.notify.showError(
            this.utils.translate(this.errorMsg),
            this.utils.translate('Update Failed!')
          );

          // get error message from API
          if (typeof this.errorMsg === 'object') {
            let msg = '';
            Object.keys(this.errorMsg).forEach((key) => {
              msg += this.errorMsg[key] + '\n';
            });
            this.utils.notify.showError(msg);
          }
        }
      );
    // }
  }

  updateSeoInfo(form: number) {
    if (form == 4) {
      this.showloader1 = true;
    }
    let body;
    body = {
      page_type: 'global',
      metadata: {
        description: this.globalSEOForm.value['description'],
        page_title: this.globalSEOForm.value['page_title'],
        keywords: this.globalSEOForm.value['keywords'],
      },
      parameter: this.store_id,
      language: this.selectedSeoLanguageCode,
      store_id: this.store_id,
    };
    this.updateSeoConfig(form, body);
  }

  updateSeoConfig(form, body) {
    this.svc.updateSeoConfig(this.bearer, body).subscribe(
      (res) => {
        this.editForm(form, false);
        this.getSEOConfig();
        setTimeout(() => {
          this.utils.notify.showSuccess(
            this.utils.translate('Updated Successfully!')
          );
          this.showloader1 = false;
          this.updateSeoForm();
        }, 2000);
      },
      (error) => {
        this.utils.notify.showError(
          this.utils.translate(this.errorMsg),
          this.utils.translate('Update Failed!')
        );
        this.showloader1 = false;
      }
    );
  }

  checkPhoneNumber() {
    // malaysia only
    console.log('sini', this.countryList);

    let prefix = this.messengerForm.value['whatsapp_number']
      .toString()
      .slice(0, 2);
    if (
      this.messengerForm.value['whatsapp_number'].toString().length <= 9 &&
      prefix != '60'
    ) {
      this.messengerForm.value['whatsapp_number'] =
        '60' + this.messengerForm.value['whatsapp_number'];
    }
  }

  checkLine() {
    return true; // remove validation
    // if (this.messengerForm.value['line_messenger'] !== '') {
    //   let substring = 'https://line.me/ti/p/';
    //   if (
    //     this.messengerForm.value['line_messenger']
    //       .toLowerCase()
    //       .indexOf(substring) >= 0
    //   ) {
    //     return (
    //       substring.length !== this.messengerForm.value['line_messenger'].length
    //     );
    //   } else {
    //     return false;
    //   }
    // } else {
    //   return true;
    // }
  }

  successModal(success) {
    this.modalService
      .open(success, {
        ariaLabelledBy: 'modal-basic-title',
        size: 'sm',
        windowClass: 'modal-success',
        centered: true,
      })
      .result.then(
        (result) => {
          this.closeResult = `Closed with: ${result}`;
          // location.reload();
        },
        (reason) => {
          this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
          // location.reload();
        }
      );
    //location.reload();
  }

  private getDismissReason(reason: any): string {
    if (reason === ModalDismissReasons.ESC) {
      return 'by pressing ESC';
    } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
      return 'by clicking on a backdrop';
    } else {
      return `with: ${reason}`;
    }
  }

  selectOnlyOne(event: any): void {
    let lang = this.language,
      target = event.target.id,
      lang_id = target.replace('check', '');
    lang.forEach((value) => {
      const checkBox = document.getElementById(
        'check' + value.dealer_language_id
      ) as HTMLInputElement;
      if (value.dealer_language_id == lang_id) {
        checkBox.checked = true;
        this.langChanges['default'] = {};
        if (value.default !== '1') {
          this.langChanges['default'][lang_id] = Object.assign({}, value);
          this.langChanges['default'][lang_id]['default'] = 1;
        }
        let toggle = document.getElementById(
          'toggle' + value.dealer_language_id
        ) as HTMLInputElement;
        toggle.disabled = true;
        this.slideDisabled[value.language_code] = true;
      } else {
        checkBox.checked = false;
        let toggle = document.getElementById(
          'toggle' + value.dealer_language_id
        ) as HTMLInputElement;
        toggle.disabled = false;
        this.slideDisabled[value.language_code] = false;
      }
    });
    this.saveStoreLanguage(1);
  }

  toggleLangStatus(event: any) {
    let lang = this.language,
      target = event.target.id,
      lang_id = target.replace('toggle', ''),
      checkbox = document.getElementById('check' + lang_id) as HTMLInputElement;
    checkbox.disabled = !checkbox.disabled;

    lang.forEach((value) => {
      let toggle = document.getElementById(
          'toggle' + lang_id
        ) as HTMLInputElement,
        check = toggle.checked ? '1' : '0';
      if (value.dealer_language_id == lang_id && value.status !== check) {
        this.langChanges['status'][lang_id] = Object.assign({}, value);
        this.langChanges['status'][lang_id]['status'] = check;
      }
      if (value.dealer_language_id == lang_id && value.status == check) {
        delete this.langChanges['status'][lang_id];
      }

      let chkBox = document.getElementById(
        'check' + value.dealer_language_id
      ) as HTMLInputElement;
      this.inputDisabled[value.language_code] = chkBox.disabled;
    });
    this.saveStoreLanguage(1);
  }

  saveStoreLanguage(event: any): void {
    let me = this,
      changes = me.langChanges;
    for (let type in changes) {
      if (!changes[type].isEmpty) {
        let langChanges = changes[type];
        for (let id in langChanges) {
          let body = {
            store_id: me.store.store_id,
            language_code: langChanges[id]['language_code'],
          };
          body[type] = langChanges[id][type];
          me.svc
            .updatePreferencesStoreLanguage(body, me.bearer, type)
            .subscribe(
              (res) => {
                this.getStoreLanguage();
                me.langChanges = {
                  default: {},
                  status: {},
                };

                this.utils.notify.showSuccess(
                  this.utils.translate('Updated Successfully!')
                );
              },
              (error) => {
                this.utils.notify.showError(
                  this.utils.translate('Update Failed!')
                );
              }
            );
        }
      }
    }
  }

  selectDefaultCountry(event: any): void {
    let country = this.countryList,
      target = event.target.id,
      country_id = target.replace('checkCountry', '');
    country.forEach((value) => {
      const checkBox = document.getElementById(
        'checkCountry' + value.dealer_country_id
      ) as HTMLInputElement;
      if (value.dealer_country_id == country_id) {
        checkBox.checked = true;
        this.countryChanges['default'] = {};
        if (value.default !== '1') {
          this.countryChanges['default'][country_id] = Object.assign({}, value);
          this.countryChanges['default'][country_id]['default'] = 1;
        }
        let toggle = document.getElementById(
          'toggleCountry' + value.dealer_country_id
        ) as HTMLInputElement;
        toggle.disabled = true;
        this.slideDisabled[value.country_code] = true;
      } else {
        checkBox.checked = false;
        let toggle = document.getElementById(
          'toggleCountry' + value.dealer_country_id
        ) as HTMLInputElement;
        toggle.disabled = false;
        this.slideDisabled[value.country_code] = false;
      }
    });
    this.saveStoreCountry(1);
  }

  toggleCountryStatus(event: any) {
    let country = this.countryList,
      target = event.target.id,
      country_id = target.replace('toggleCountry', ''),
      checkbox = document.getElementById(
        'checkCountry' + country_id
      ) as HTMLInputElement;
    checkbox.disabled = !checkbox.disabled;

    country.forEach((value) => {
      let toggle = document.getElementById(
          'toggleCountry' + country_id
        ) as HTMLInputElement,
        check = toggle.checked ? '1' : '0';
      if (value.dealer_country_id == country_id && value.status !== check) {
        this.countryChanges['status'][country_id] = Object.assign({}, value);
        this.countryChanges['status'][country_id]['status'] = check;
      }
      if (value.dealer_country_id == country_id && value.status == check) {
        delete this.countryChanges['status'][country_id];
      }

      let chkBox = document.getElementById(
        'checkCountry' + value.dealer_country_id
      ) as HTMLInputElement;
      this.inputDisabled[value.country_code] = chkBox.disabled;
    });
    this.saveStoreCountry(1);
  }

  saveStoreCountry(event: any): void {
    let me = this,
      changes = me.countryChanges;
    for (let type in changes) {
      if (!changes[type].isEmpty) {
        let countryChanges = changes[type];
        for (let id in countryChanges) {
          let body = {
            store_id: me.store.store_id,
            country_code: countryChanges[id]['country_code'],
          };
          body[type] = countryChanges[id][type];
          me.svc.updatePreferencesStoreCountry(body, me.bearer, type).subscribe(
            (res) => {
              this.getStoreCountry();
              me.countryChanges = {
                default: {},
                status: {},
              };

              this.utils.notify.showSuccess(
                this.utils.translate('Updated Successfully!')
              );
            },
            (error) => {
              this.utils.notify.showError(
                this.utils.translate('Update Failed!')
              );
            }
          );
        }
      }
    }
  }

  getWhatsappStoreConfig() {
   this.storeInfoService.fetchStoreInfo();
    // this.storeInfo$.subscribe(
    //   (res) => {
    //     let store_social_link = res?.store_social_link
    //     ? JSON.parse(res?.store_social_link)
    //     : {};
    //   me.whatsapp_flag = store_social_link?.whatsapp_flag;
    //   me.whatsapp_number = store_social_link?.whatsapp_number;
    //   me.messengerForm.value['whatsapp_number'] = me.whatsapp_number;
    //   me.messengerForm.controls['whatsapp_number'].setValue(
    //     me.whatsapp_number
    //   );
    //   }
    // );
  }

  getSEOConfig() {
    let me = this;
    me.svc
      .getGlobalSEO(me.bearer, me.store_id, me.dashboardLanguageCode)
      .subscribe((res) => {
        me.globalSeo = res['data'];
        me.description = me.globalSeo?.description;
        me.page_title = me.globalSeo?.page_title;
        me.keywords = me.globalSeo?.keywords;
        me.globalSEOForm.value['description'] = this.description;
        me.globalSEOForm.value['page_title'] = this.page_title;
        me.globalSEOForm.value['keywords'] = this.keywords;

        this.globalSEOForm = this.formBuilder.group({
          description: [this.description],
          keywords: [this.keywords],
          page_title: [this.page_title],
        });
      });
  }

  getAllDealerConfig() {
    this.svc
      .getAllDealerConfig(this.bearer, this.dealer_id)
      .subscribe((res) => {
        this.emailLanguageCode = res['data']['email_language'] ?? 'en-US';
        this.selectedEmailLanguageCode =
          res['data']['email_language'] ?? 'en-US';
      });
  }


  getAllStoreConfig() {
    let me = this;
    me.svc.getAllStoreConfig(me.bearer, me.store.store_id).subscribe((res) => {
      me.analyticsData = res['data'];
      me.facebookPixels = me.parseFacebookPixels(res['data']['facebook_pixel']);
      // Which pixels have a CAPI token. The tokens themselves are never sent
      // back -- the endpoint serving them is public.
      me.capiTokenSet = res['data']['facebook_capi_token_set'] || {};
      me.google_analytics_id = (res['data']['google_analytics'] === '0' || res['data']['google_analytics'] === 0) ? '' : (res['data']['google_analytics'] ?? '');
      me.tiktok_pixel_id = (res['data']['tiktok_pixel'] === '0' || res['data']['tiktok_pixel'] === 0) ? '' : (res['data']['tiktok_pixel'] ?? '');
      me.showCountrySelector = res['data']['country_config'];
      me.showLanguageSelector = res['data']['language_config'];
      me.showNonCodSelector = +res['data']['non_cod'];
      me.showCodSelector = +res['data']['cod'];
      me.showSelfCollectSelector = +res['data']['self_collect'];
      me.showInstallmentSelector = +res['data']['installment'];
      me.showSubscriptionSelector = +res['data']['subscription'];
      me.paymentEnabledByCountry = {};
      me.paymentToggleTypes.forEach((type) => {
        me.paymentEnabledByCountry[type] = parseCountryMap(res['data'][type + BY_COUNTRY_SUFFIX]);
      });
      me.ensureCourierSelection();
      me.isShowCountrySetting = Boolean(Number(me.showCountrySelector));
      me.isShowLanguageSetting = Boolean(Number(me.showLanguageSelector));
      me.autoApproveCod = +res['data']['auto_approve_cod'];
      me.autoApproveCollect = +res['data']['auto_approve_collect'];
      me.autoApproveByCountry = {
        auto_approve_cod: parseCountryMap(res['data']['auto_approve_cod' + BY_COUNTRY_SUFFIX]),
        auto_approve_collect: parseCountryMap(res['data']['auto_approve_collect' + BY_COUNTRY_SUFFIX]),
      };
      me.testimonialGet = res['data']['testimonial'];
      me.loadingIconGet = res['data']['storeLoading'];

      me.checkoutTheme =
        res['data']['checkout_theme'] === 'split' ? 'split' : 'classic';
      me.checkoutThemeSaved = me.checkoutTheme;
      me.checkoutThemeLoaded = true;

      if(me.testimonialGet === "true"){
        this.testimonialToggle = true;
      }else{
        this.testimonialToggle = false;
      }


      me.analyticsForm = me.formBuilder.group({
        google_analytics_id: [me.google_analytics_id],
        tiktok_pixel_id: [me.tiktok_pixel_id],
      });
      const social = res['data']['social_media'] ?? null;
      me.social_media_links = JSON.parse(social);
      me.twitter = me.social_media_links?.twitter;
      me.website = me.social_media_links?.website;
      me.youtube = me.social_media_links?.youtube;
      me.facebook = me.social_media_links?.facebook;
      me.instagram = me.social_media_links?.instagram;
      me.wechat = me.social_media_links?.wechat;
      me.tiktok = me.social_media_links?.tiktok;

      if (me.twitter == '' || me.twitter == null) {
        me.twitter = 'https://twitter.com/';
      }
      if (me.website == '' || me.website == null) {
        me.website = 'https://';
      }
      if (me.youtube == '' || me.youtube == null) {
        me.youtube = 'https://www.youtube.com/';
      }
      if (me.facebook == '' || me.facebook == null) {
        me.facebook = 'https://www.facebook.com/';
      }
      if (me.instagram == '' || this.instagram == null) {
        this.instagram = 'https://www.instagram.com/';
      }
      if (me.wechat == '' || me.wechat == null) {
        me.wechat = 'https://';
      }
      if (me.tiktok == '' || me.tiktok == null) {
        me.tiktok = 'https://tiktok.com/@';
      }

      me.socialMediaForm = me.formBuilder.group({
        twitter: me.twitter,
        website: me.website,
        youtube: me.youtube,
        facebook: me.facebook,
        instagram: me.instagram,
        wechat: me.wechat,
        tiktok: me.tiktok,
      });

      me.whatsapp_number_thank_you_page = res['data']['whatsapp_number_thank_you_page'] || '';
      me.checkoutPage.controls['whatsapp_number_thank_you_page'].setValue(me.whatsapp_number_thank_you_page);

      me.isCheckoutStepsSingle = Number(res['data']['is_checkout_single'] ?? 0);

      let snippetScriptsData = res['data']['snippetScript'];
      let snippetScripts = {};
      try {
        snippetScripts = JSON.parse(snippetScriptsData);
      } catch {}

      this.headerScriptValue = snippetScripts['headerScript'] ?? '';
      this.bodyScriptValue = snippetScripts['bodyScript'] ?? '';
      this.footerScriptValue = snippetScripts['footerScript'] ?? '';

      this.customSnippet.controls['headerScriptValue'].setValue(
        this.headerScriptValue
      );
      this.customSnippet.controls['bodyScriptValue'].setValue(
        this.bodyScriptValue
      );
      this.customSnippet.controls['footerScriptValue'].setValue(
        this.footerScriptValue
      );

      this.customSnippetBase = JSON.stringify(this.customSnippet.value);

      const hicommScript = res['data']['hicomm_script'];
      this.hicommScriptValue =
        typeof hicommScript === 'string' && hicommScript !== '0' ? hicommScript : '';
      this.hicommScriptBase = this.hicommScriptValue;
      // The tab may already be open with an empty editor if the configs
      // arrived after it mounted.
      const hicommView = this.hicommScriptView;
      if (
        hicommView?.dom.isConnected &&
        hicommView.state.doc.toString() !== this.hicommScriptValue
      ) {
        hicommView.dispatch({
          changes: { from: 0, to: hicommView.state.doc.length, insert: this.hicommScriptValue },
        });
      }

      this.line_messenger =
        res['data']['line_messenger'] === '0'
          ? ''
          : res['data']['line_messenger'];

      this.messengerForm.controls['line_messenger'].setValue(
        this.line_messenger
      );

      this.favIcoImgURL =
        res['data']['favicon_img'] ??
        'https://estore-cdn-dev.fiv5s.dev/favicon.ico';
      this.ogimgURL =
        res['data']['og_img'] ??
        'https://cdn.estore5s.com/asset/estore-logo-transparent.png';
    });
  }

  analyticsDataUpdate(name, editId) {
    const analyticsTypes = {
      google: {
        id: 'google_analytics',
        name: 'Google Analytics',
      },
      tiktok: {
        id: 'tiktok_pixel',
        name: 'TikTok Pixel',
      },
    };

    let me = this,
      outputName = '',
      body = {
        store_id: me.store.store_id,
        name: analyticsTypes[name]['id'],
        value: analyticsTypes[name]['id'],
      };
    const rawVal = me.analyticsForm.value[body.name + '_id'];
    const trimmedVal = (rawVal || '').trim();
    body['value'] = trimmedVal === '' ? 0 : trimmedVal;
    outputName = analyticsTypes[name]['name'];

    me.svc.updateConfig(me.bearer, body).subscribe(
      (res) => {
        this.editForm(editId, false);
        me.getAllStoreConfig();
        this.utils.notify.showSuccess(
          this.utils.translate('Updated Successfully!'),
          outputName
        );
      },
      (error) => {
        this.utils.notify.showError(
          this.utils.translate('Update Failed!'),
          outputName
        );
      }
    );
  }

  // Anything other than 'account'/'manual' means browser-only, matching
  // PixelConfigLogic::normaliseCapiMode() on the server. A pixel saved before
  // this field existed therefore keeps firing browser-side only.
  normaliseCapiMode(raw): 'none' | 'account' | 'manual' {
    const mode = String(raw ?? '').trim().toLowerCase();
    return mode === 'account' || mode === 'manual' ? mode : 'none';
  }

  parseFacebookPixels(raw): FacebookPixel[] {
    if (raw === null || raw === undefined || raw === '' || raw === 0 || raw === '0') {
      return [];
    }
    try {
      const parsed = JSON.parse(raw);
      if (Array.isArray(parsed)) {
        return parsed
          .filter((p) => p && p.pixel_id)
          .map((p) => ({
            pixel_id: String(p.pixel_id).trim(),
            countries:
              Array.isArray(p.countries) && p.countries.length
                ? p.countries.map((c) => String(c))
                : p.country
                ? [String(p.country)]
                : ['GLOBAL'],
            capi: this.normaliseCapiMode(p.capi),
          }));
      }
    } catch (e) {
      // legacy bare pixel id, handled below
    }
    return [{ pixel_id: String(raw).trim(), countries: ['GLOBAL'], capi: 'none' }];
  }

  // Country codes whose flag asset failed to load; badges fall back to the
  // bare country code text.
  pixelFlagFailed: { [code: string]: boolean } = {};

  getFlagImageURL(code: string): string {
    return `https://cdn.estore5s.com/asset/flags/${String(code).toLowerCase()}.png`;
  }

  onPixelFlagError(code: string) {
    this.pixelFlagFailed[code] = true;
  }

  pixelCountryLabel(code: string): string {
    if (code === 'GLOBAL') {
      return this.utils.translate('Global');
    }
    const country = (this.pixelCountryList || []).find(
      (c) => c.country_code === code
    );
    if (!country) {
      return code;
    }
    const name = country.country_name_full || country.country_name;
    // Country codes are <origin><destination> (MY = Malaysia domestic,
    // MYSG = Malaysia serving Singapore, HKMO = Hong Kong serving Macau), and
    // the stored names already spell that out -- so show the name as the data
    // gives it rather than deriving a label. Only TW and TWTW are stored under
    // an identical name, so the code is appended for those alone.
    return this.isPixelCountryNameAmbiguous(name)
      ? `${name} (${country.country_code})`
      : name;
  }

  // One entry per country_code, keeping the first occurrence. Rows with no code
  // are dropped -- store_dealer_country has blank-code rows that would otherwise
  // render an empty chip.
  buildPixelCountryList(list: any[]): any[] {
    const seen = new Set<string>();
    return (list || []).filter((c) => {
      const code = (c?.country_code || '').trim();
      if (!code || seen.has(code)) {
        return false;
      }
      seen.add(code);
      return true;
    });
  }

  isPixelCountryNameAmbiguous(countryName: string): boolean {
    if (!countryName) {
      return false;
    }
    return (
      (this.pixelCountryList || []).filter(
        (c) => (c.country_name_full || c.country_name) === countryName
      ).length > 1
    );
  }

  openPixelDialog(dialog, index: number | null = null) {
    this.pixelEditIndex = index;
    this.pixelOriginalId = index === null ? '' : (this.facebookPixels[index]?.pixel_id || '');
    if (index === null) {
      this.newPixelId = '';
      this.newPixelCountries = ['GLOBAL'];
      this.newPixelCapiSource = 'none';
      this.newPixelHadToken = false;
      this.newPixelWasAccountSourced = false;
    } else {
      const pixel = this.facebookPixels[index];
      this.newPixelId = pixel.pixel_id;
      this.newPixelCountries = [...pixel.countries];
      this.newPixelCapiSource = pixel.capi || 'none';
      // The stored token is never sent to the dashboard, so the input starts
      // blank and leaving it blank keeps whatever is saved.
      this.newPixelHadToken = !!this.capiTokenSet[pixel.pixel_id];
      this.newPixelWasAccountSourced = (pixel.capi || 'none') === 'account';
    }
    this.newPixelCapiToken = '';
    this.pixelDialogError = '';
    this.tokenCheckState = 'idle';
    this.tokenCheckError = '';
    this.tokenCheckedPair = '';

    // Editing settles the id and source already, so only the countries are
    // still in question -- start on the last step and skip the rest.
    // Editing walks the same three steps as adding, prefilled. It used to jump
    // to step 3, which meant the pixel id and the token -- both of which live
    // on step 2 -- could not be reached at all.
    this.pixelStep = 1;
    // Adding opens on the recommended setup rather than on an empty choice;
    // editing opens on whatever the pixel already is.
    this.pixelSetupKind = index === null
      ? 'capi'
      : (this.facebookPixels[index]?.capi === 'none' ? 'pixel' : 'capi');
    // A manual pixel has to open on the Manual tab, or step 2 shows the
    // account picker and its token field is nowhere to be found. With the
    // picker disabled, manual is where every CAPI pixel opens.
    this.pixelEntryMode =
      !this.capiConnectEnabled ||
      (index !== null && this.facebookPixels[index]?.capi === 'manual')
        ? 'manual'
        : 'connect';
    this.showCreatePixel = false;
    this.newPixelName = '';
    this.newPixelAccountId = '';
    this.nexusError = '';
    this.nexusSsoLink = '';
    this.nexusPixels = [];
    this.nexusAdAccounts = [];

    this.modalService.open(dialog, {
      ariaLabelledBy: 'pixel-dialog-title',
      centered: true,
    });

    // When editing an existing pixel that has a saved token, automatically fetch
    // and show the saved token in the Conversions API access token text box
    if (index !== null && this.newPixelHadToken) {
      this.revealPixelCapiToken();
    }
  }

  /**
   * Step 1: browser-only pixel, or pixel + Conversions API.
   *
   * Choosing CAPI is what triggers the nexus fetch -- someone who only wants a
   * plain pixel never pays for it.
   */
  choosePixelSetupKind(kind: 'pixel' | 'capi') {
    this.pixelSetupKind = kind;
    this.pixelDialogError = '';

    if (kind === 'pixel') {
      // Browser-only: no token of any kind.
      this.newPixelCapiSource = 'none';
      this.newPixelCapiToken = '';
      return;
    }

    // Nothing to fetch while the picker is disabled -- step 2 is the manual
    // form only.
    if (
      this.capiConnectEnabled &&
      !this.nexusPixels.length &&
      !this.nexusError &&
      !this.nexusLoading
    ) {
      this.loadNexusPixels();
    }
  }

  /**
   * Fetch the dealer's pixels from their Facebook connection.
   *
   * A dealer with no usable connection is the common case, so this is not
   * treated as an error: nexusError explains why and nexusSsoLink offers
   * re-connection, while manual entry stays available throughout.
   */
  loadNexusPixels() {
    const me = this;
    me.nexusLoading = true;
    me.nexusError = '';
    me.nexusSsoLink = '';

    me.svc
      .getPixelList(me.bearer, {
        store_id: me.store.store_id,
        // Where nexus should send them back to once Facebook is connected.
        // The flag is what this page looks for on the way back in.
        return_url: me.capiReturnUrl(),
      })
      .subscribe(
      (res) => {
        me.nexusLoading = false;
        const data = res['data'] ?? {};

        if (!data.eligible) {
          me.nexusError = me.nexusReasonText(data.reason);
          me.nexusSsoLink = data.sso_link || '';
          // Stay on the Connect tab. It is not a dead end -- the empty state
          // names the specific reason and offers both Connect Facebook and
          // Enter manually. Switching the tab for them hid the connect path
          // entirely, so a dealer who simply had not linked Facebook yet was
          // routed straight to pasting a token, which is the fallback rather
          // than the intended setup.
          return;
        }

        // Kept on the eligible path too, so the dealer can authorise a
        // DIFFERENT Facebook account. This list only ever shows what the
        // currently connected account can see, and being connected once must
        // not mean being stuck with that account's pixels forever.
        me.nexusSsoLink = data.sso_link || '';
        me.nexusPixels = Array.isArray(data.pixels) ? data.pixels : [];
        me.nexusAdAccounts = Array.isArray(data.ad_accounts) ? data.ad_accounts : [];
        me.newPixelAccountId = me.nexusAdAccounts.length
          ? me.nexusAdAccounts[0].account_id
          : '';
      },
      () => {
        me.nexusLoading = false;
        // Same as above: the message already tells them manual entry is
        // available, and the empty state gives them the button. A transient
        // failure to reach nexus should not decide how they set up CAPI.
        me.nexusError = me.utils.translate(
          'Could not load your Facebook pixels. You can still enter a Pixel ID manually.'
        );
      }
    );
  }

  // nexus reports why a dealer is ineligible; each reason needs a different
  // action from the user, so they are not collapsed into one message.
  nexusReasonText(reason: string): string {
    switch (reason) {
      case 'expired':
        return this.utils.translate(
          'Your Facebook connection has expired. Reconnect to choose from your pixels.'
        );
      case 'missing_scope':
        return this.utils.translate(
          'Your Facebook connection is missing the ads permission. Reconnect to grant it.'
        );
      case 'invalid':
        return this.utils.translate(
          'Your Facebook connection is no longer valid. Reconnect to choose from your pixels.'
        );
      default:
        return this.utils.translate(
          'No Facebook account is connected. Connect one to choose from your pixels.'
        );
    }
  }

  /**
   * Called as either manual field changes.
   *
   * Only clears a previous verdict -- the pair is checked when Next is
   * pressed, not while typing, so nothing reaches Meta until the operator
   * says they are done.
   */
  onManualPixelFieldChange() {
    this.pixelDialogError = '';

    const id = (this.newPixelId || '').trim();

    // The saved token belongs to the id the dialog opened with. Once the id
    // differs there is nothing to "keep", so the input must stop offering it:
    // otherwise the operator leaves the box empty believing the token carried
    // over, and saves a CAPI pixel with no credential behind it.
    if (this.pixelEditIndex !== null) {
      this.newPixelHadToken =
        id === this.pixelOriginalId && !!this.capiTokenSet[id];
    }

    const pair =
      id + ':' + (this.newPixelCapiToken || '').trim();

    // An edit discards the previous verdict, so a tick never outlives the
    // values it applied to.
    if (pair !== this.tokenCheckedPair) {
      this.tokenCheckState = 'idle';
      this.tokenCheckError = '';
      this.tokenCheckedPair = '';
    }
  }

  /**
   * Check the pair against Meta, then continue to the country step if it is
   * usable.
   *
   * Runs on Next rather than while typing: one request per attempt instead of
   * one per pause in typing, and the operator gets the answer at the moment
   * they are asking to move on.
   *
   * `checked: false` means Meta could not be reached -- treated as unknown
   * rather than invalid, and allowed through, because refusing a good token
   * over a transient failure is the worse outcome.
   */
  private checkManualTokenThenContinue() {
    const me = this;
    const pixelId = (me.newPixelId || '').trim();
    const token = (me.newPixelCapiToken || '').trim();
    const pair = pixelId + ':' + token;

    me.tokenCheckState = 'checking';
    me.tokenCheckError = '';
    me.pixelDialogError = '';

    // True if the fields still hold the pair this response was for. A late
    // response must not act on values the operator has since changed.
    const stillCurrent = () =>
      pair ===
      (me.newPixelId || '').trim() + ':' + (me.newPixelCapiToken || '').trim();

    me.svc
      .verifyPixelCapiToken(me.bearer, {
        store_id: me.store.store_id,
        pixel_id: pixelId,
        token,
      })
      .subscribe(
        (res) => {
          if (!stillCurrent()) {
            return;
          }

          const data = res['data'] ?? {};
          me.tokenCheckedPair = pair;

          if (data.valid || data.checked === false) {
            me.tokenCheckState = data.valid ? 'valid' : 'unknown';
            me.tokenCheckError = '';
            me.newPixelCapiSource = 'manual';
            me.pixelStep = 3;
            return;
          }

          me.tokenCheckState = 'invalid';
          // Meta's own wording names the pixel the token belongs to, which is
          // the actionable part.
          me.tokenCheckError =
            data.error || me.utils.translate('Meta rejected this access token.');
        },
        () => {
          if (!stillCurrent()) {
            return;
          }
          // Our own request failed: unknown, not invalid -- so continue.
          me.tokenCheckedPair = pair;
          me.tokenCheckState = 'unknown';
          me.tokenCheckError = '';
          me.newPixelCapiSource = 'manual';
          me.pixelStep = 3;
        }
      );
  }

  /**
   * The URL nexus should return the dealer to after they connect Facebook.
   *
   * Carries a flag rather than the token: the token is fetched server-side
   * afterwards, so it never travels through a URL, browser history or a
   * referrer header.
   */
  capiReturnUrl(): string {
    const base = window.location.origin + window.location.pathname;
    return base + '?capi_connected=1';
  }

  /**
   * Handle the return from nexus after connecting Facebook.
   *
   * The flag only says they came back; whether the connection actually works
   * is decided by re-fetching the pixel list, which resolves the token
   * server-side. So a dealer who bailed out of the Facebook flow does not get
   * told it succeeded.
   */
  private handleCapiReturn() {
    // Read from the URL directly rather than via ActivatedRoute: this needs no
    // router injection, and works the same whether Angular routed here or the
    // browser did a full navigation back from nexus.
    let connected: string | null = null;
    let pixelId: string | null = null;
    try {
      const params = new URL(window.location.href).searchParams;
      connected = params.get('capi_connected');
      // The pixel the dealer chose in nexus. Only the id travels back -- the
      // access token is resolved server-side, never through a URL.
      pixelId = params.get('capi_pixel_id');
    } catch (e) {
      return;
    }

    if (connected !== '1') {
      return;
    }

    // Drop the flags so a refresh does not replay this.
    try {
      const url = new URL(window.location.href);
      url.searchParams.delete('capi_connected');
      url.searchParams.delete('capi_pixel_id');
      window.history.replaceState({}, '', url.toString());
    } catch (e) {
      // Non-fatal: the flags would simply replay on refresh.
    }

    // A stale link from before the picker was switched off. The flags are
    // already stripped above, so there is nothing to announce: telling them
    // Facebook is connected would point at a flow that is no longer there.
    if (!this.capiConnectEnabled) {
      return;
    }

    this.selectTab('Tracking & Analytics');
    this.capiJustConnected = true;

    const chosen = (pixelId || '').trim();
    // Digits only, same rule the pixel config enforces: this value came back
    // through a URL, so it is treated as untrusted input rather than trusted
    // because nexus sent it.
    this.capiReturnedPixelId = /^[0-9]+$/.test(chosen) ? chosen : '';

    this.utils.notify.showSuccess(
      this.utils.translate('Facebook connected'),
      'Conversions API'
    );

    if (this.capiReturnedPixelId) {
      this.utils.msgBox.open({
        message:
          this.utils.translate(
            'Your Facebook account is connected and the pixel you chose is ready to add. Purchases will be sent from our server as well as the browser, so sales are still counted when the browser event is blocked.'
          ) + `\n\n${this.capiReturnedPixelId}`,
        title: this.utils.translate('Conversions API is ready'),
        icon: 'success',
        contentClassList: 'whitespace-pre-line',
        buttonList: [
          { text: this.utils.translate('Later') },
          {
            text: this.utils.translate('Add this pixel'),
            style: 'primary',
            onClick: () => this.openPixelDialogForReturnedPixel(),
          },
        ],
      });
      return;
    }

    // Connected, but no pixel came back -- they skipped the picker, or it had
    // nothing usable to offer. Saying "ready" here would overstate it: nothing
    // sends server-side until a pixel is actually configured. Name the gap and
    // offer the way to close it.
    this.utils.msgBox.open({
      message: this.utils.translate(
        'Your Facebook account is connected, but no pixel was selected. Add a pixel with the Conversions API to start sending purchases from our server as well as the browser.'
      ),
      title: this.utils.translate('No pixel selected yet'),
      icon: 'info',
      contentClassList: 'whitespace-pre-line',
      buttonList: [
        { text: this.utils.translate('Later') },
        {
          text: this.utils.translate('Add a pixel'),
          style: 'primary',
          onClick: () => this.openPixelDialogForCapi(),
        },
      ],
    });
  }

  /**
   * Open the add-pixel flow ready for CAPI, with no pixel preselected.
   *
   * Used when they connected but skipped choosing: the account is connected,
   * so the CAPI path is the right starting point -- they just still have to
   * say which pixel.
   */
  private openPixelDialogForCapi() {
    if (!this.pixelDialogRef) {
      return;
    }

    this.openPixelDialog(this.pixelDialogRef);
    this.pixelSetupKind = 'capi';
    this.pixelEntryMode = 'connect';
    this.pixelStep = 2;
  }

  /**
   * Open the add-pixel flow with the pixel chosen in nexus already filled in.
   *
   * Straight to the country step: the id and its token source are both
   * settled by having come from the connected account.
   */
  private openPixelDialogForReturnedPixel() {
    if (!this.capiReturnedPixelId || !this.pixelDialogRef) {
      return;
    }

    // Already configured: nothing to add.
    const existing = this.facebookPixels.some(
      (p) => p.pixel_id === this.capiReturnedPixelId
    );
    if (existing) {
      this.utils.notify.showSuccess(
        this.utils.translate('This Pixel ID is already added.'),
        'Conversions API'
      );
      return;
    }

    this.openPixelDialog(this.pixelDialogRef);
    this.newPixelId = this.capiReturnedPixelId;
    this.pixelSetupKind = 'capi';
    this.pixelEntryMode = 'connect';
    this.newPixelCapiSource = 'account';
    this.pixelStep = 3;
  }

  setPixelEntryMode(mode: 'connect' | 'manual') {
    // The tabs are hidden while the picker is disabled; this guards the paths
    // that set the mode without going through them.
    this.pixelEntryMode = !this.capiConnectEnabled ? 'manual' : mode;
    this.pixelDialogError = '';
  }

  // Choosing a pixel from the connected account settles both the id and the
  // token source: server-side sending uses that account's token.
  chooseNexusPixel(pixelId: string) {
    this.newPixelId = pixelId;
    this.newPixelCapiSource = 'account';
    this.pixelDialogError = '';
  }

  createNexusPixel() {
    const name = (this.newPixelName || '').trim();
    if (name === '') {
      this.pixelDialogError = this.utils.translate('Enter a name for the new pixel.');
      return;
    }
    if (!this.newPixelAccountId) {
      this.pixelDialogError = this.utils.translate('Select an ad account.');
      return;
    }

    const me = this;
    me.creatingPixel = true;
    me.pixelDialogError = '';

    me.svc
      .createPixel(me.bearer, {
        store_id: me.store.store_id,
        account_id: me.newPixelAccountId,
        name,
      })
      .subscribe(
        (res) => {
          me.creatingPixel = false;
          const data = res['data'] ?? {};

          if (!data.created) {
            // Meta's own message says what actually went wrong (pixel limit
            // reached, no permission on the account), so show it verbatim.
            me.pixelDialogError =
              data.error ||
              me.utils.translate('Could not create the pixel.');
            return;
          }

          const account = me.nexusAdAccounts.find(
            (a) => a.account_id === me.newPixelAccountId
          );
          me.nexusPixels = [
            {
              pixel_id: data.pixel_id,
              name: data.name || name,
              account_id: me.newPixelAccountId,
              account_name: account ? account.name : '',
            },
            ...me.nexusPixels,
          ];
          me.showCreatePixel = false;
          me.newPixelName = '';
          me.chooseNexusPixel(data.pixel_id);
        },
        () => {
          me.creatingPixel = false;
          me.pixelDialogError = me.utils.translate('Could not create the pixel.');
        }
      );
  }

  /**
   * Forward through the wizard, validating the step being left.
   */
  nextPixelStep() {
    if (this.pixelStep === 1) {
      if (this.pixelSetupKind === null) {
        this.pixelDialogError = this.utils.translate('Choose how you want to set this up.');
        return;
      }
      this.pixelDialogError = '';

      // The nexus fetch normally rides on choosePixelSetupKind(). 'capi' is
      // preselected now, so a dealer who never clicks the option would reach
      // the picker with nothing in it -- load here too. Same guard, so the
      // click path does not fetch twice.
      if (
        this.capiConnectEnabled &&
        this.pixelSetupKind === 'capi' &&
        !this.nexusPixels.length &&
        !this.nexusError &&
        !this.nexusLoading
      ) {
        this.loadNexusPixels();
      }

      this.pixelStep = 2;
      return;
    }

    if (this.pixelStep === 2 && this.validatePixelIdStep()) {
      // A manual CAPI token is verified with Meta before moving on; the step
      // advances from the response. Every other path continues immediately.
      if (
        this.pixelSetupKind === 'capi' &&
        this.pixelEntryMode === 'manual' &&
        (this.newPixelCapiToken || '').trim() !== '' &&
        this.tokenCheckState !== 'valid' &&
        this.tokenCheckState !== 'unknown'
      ) {
        this.checkManualTokenThenContinue();
        return;
      }

      this.pixelDialogError = '';
      this.pixelStep = 3;
    }
  }

  /**
   * The pixel id must be usable before the country step, whichever path
   * produced it.
   */
  private validatePixelIdStep(): boolean {
    const pixelId = (this.newPixelId || '').trim();

    if (!/^[0-9]+$/.test(pixelId)) {
      this.pixelDialogError =
        this.pixelSetupKind === 'capi' && this.pixelEntryMode === 'connect'
          ? this.utils.translate('Select a pixel to continue.')
          : this.utils.translate('Pixel ID must contain digits only.');
      return false;
    }

    const duplicate = this.facebookPixels.some(
      (p, i) => p.pixel_id === pixelId && i !== this.pixelEditIndex
    );
    if (duplicate) {
      this.pixelDialogError = this.utils.translate('This Pixel ID is already added.');
      return false;
    }

    if (
      this.pixelEditIndex === null &&
      this.facebookPixels.length >= this.maxFacebookPixels
    ) {
      this.pixelDialogError = this.utils.translate('You can add up to 10 Pixel IDs.');
      return false;
    }

    // Resolve where this pixel's token comes from. Browser-only was already
    // settled on step 1; the CAPI paths settle here.
    if (this.pixelSetupKind === 'pixel') {
      this.newPixelCapiSource = 'none';
    } else if (this.pixelEntryMode === 'connect') {
      // Picking from the connected account settles the token too: sends use
      // that account.
      this.newPixelCapiSource = 'account';
    } else {
      // Manual CAPI: a token is what makes it server-side. Without one it
      // still fires in the browser, so this is not an error -- it just is not
      // CAPI.
      const token = (this.newPixelCapiToken || '').trim();

      // Whether the token is usable is decided by the check nextPixelStep()
      // runs; this only records the source.
      this.newPixelCapiSource =
        token !== '' || this.newPixelHadToken ? 'manual' : 'none';
    }

    return true;
  }

  backPixelStep() {
    this.pixelDialogError = '';
    if (this.pixelStep > 1) {
      this.pixelStep = (this.pixelStep - 1) as 1 | 2 | 3;
    }
  }

  setNewPixelCapiSource(source: 'none' | 'account' | 'manual') {
    this.newPixelCapiSource = source;
    this.pixelDialogError = '';
  }

  // The "how does this work?" dialog next to the Conversions API options.
  openCapiInfoDialog(dialog) {
    this.modalService.open(dialog, {
      ariaLabelledBy: 'capi-info-title',
      centered: true,
      scrollable: true,
    });
  }

  isNewPixelCountrySelected(code: string): boolean {
    return this.newPixelCountries.includes(code);
  }

  // Global covers every storefront, so it is mutually exclusive with
  // country-specific selections: picking it clears the rest and vice versa.
  toggleNewPixelCountry(code: string) {
    this.pixelDialogError = '';
    if (code === 'GLOBAL') {
      this.newPixelCountries = ['GLOBAL'];
      return;
    }
    this.newPixelCountries = this.newPixelCountries.filter(
      (c) => c !== 'GLOBAL'
    );
    if (this.newPixelCountries.includes(code)) {
      this.newPixelCountries = this.newPixelCountries.filter(
        (c) => c !== code
      );
    } else {
      this.newPixelCountries = [...this.newPixelCountries, code];
    }
  }

  savePixelForm(modal) {
    const pixelId = (this.newPixelId || '').trim();
    if (!/^\d+$/.test(pixelId)) {
      this.pixelDialogError = this.utils.translate(
        'Pixel ID must contain digits only.'
      );
      return;
    }

    // Editing sets the source from the radio on step 3, without passing
    // through validatePixelIdStep() where the add flow resolves it. Mirror the
    // one rule that matters here: 'manual' with no token pasted and none
    // saved is not CAPI at all. Saving it as 'manual' would leave the server
    // reporting "set to a manual token, but none is saved" on every event.
    if (
      this.pixelEditIndex !== null &&
      this.newPixelCapiSource === 'manual' &&
      (this.newPixelCapiToken || '').trim() === '' &&
      !this.newPixelHadToken
    ) {
      this.newPixelCapiSource = 'none';
    }
    if (!this.newPixelCountries.length) {
      this.pixelDialogError = this.utils.translate(
        'Select at least one country.'
      );
      return;
    }
    if (
      this.pixelEditIndex === null &&
      this.facebookPixels.length >= this.maxFacebookPixels
    ) {
      this.pixelDialogError = this.utils.translate(
        'You can add up to 10 Pixel IDs.'
      );
      return;
    }
    const duplicate = this.facebookPixels.some(
      (p, i) => p.pixel_id === pixelId && i !== this.pixelEditIndex
    );
    if (duplicate) {
      this.pixelDialogError = this.utils.translate(
        'This Pixel ID is already added.'
      );
      return;
    }
    // The token is optional throughout: a pixel with no token still fires in
    // the browser, it just does not send server-side. Step 1 already settled
    // the source, so nothing to validate here.
    const token = (this.newPixelCapiToken || '').trim();

    const entry: FacebookPixel = {
      pixel_id: pixelId,
      countries: [...this.newPixelCountries],
      capi: this.newPixelCapiSource,
    };
    const list = this.facebookPixels.map((p) => ({
      ...p,
      countries: [...p.countries],
    }));
    if (this.pixelEditIndex === null) {
      list.push(entry);
    } else {
      list[this.pixelEditIndex] = entry;
    }

    // A renamed pixel leaves its token behind: tokens are keyed by pixel id,
    // and the old key is not touched by anything that follows. Left alone it
    // is a live ads credential stored under an id nothing references any more.
    const renamedFrom =
      this.pixelEditIndex !== null &&
      this.pixelOriginalId !== '' &&
      this.pixelOriginalId !== pixelId &&
      !!this.capiTokenSet[this.pixelOriginalId]
        ? this.pixelOriginalId
        : '';

    // The pixel list and the token are two separate writes -- the token never
    // travels inside facebook_pixel, which is public. Save the list first, so
    // a token is only ever attached to a pixel that exists.
    this.persistPixels(list, modal, () => {
      if (renamedFrom !== '') {
        this.clearPixelToken(renamedFrom);
      }
      this.persistPixelToken(pixelId, token);
    });
  }

  // Whether the stored token is being fetched for display, so the button can
  // show progress and not fire twice.
  revealingToken = false;

  /**
   * Fetch the saved token and put it in the input.
   *
   * Only reachable while editing a pixel that has a stored token, and only on
   * an explicit click: the value never arrives with the page. Once revealed it
   * behaves like a pasted token -- the input is no longer empty, so the
   * "leave empty to keep what is saved" path no longer applies and the value
   * is written back on save, which is harmless since it is the same value.
   */
  revealPixelCapiToken() {
    if (this.revealingToken) {
      return;
    }

    const pixelId = (this.newPixelId || '').trim();
    if (pixelId === '') {
      return;
    }

    this.revealingToken = true;
    this.pixelDialogError = '';

    this.svc
      .revealPixelCapiToken(this.bearer, {
        store_id: this.store.store_id,
        pixel_id: pixelId,
      })
      .subscribe(
        (res) => {
          this.revealingToken = false;
          const value = res?.['data']?.['token'] || '';

          if (value === '') {
            this.pixelDialogError = this.utils.translate(
              'No access token is saved for this Pixel ID.'
            );
            return;
          }

          this.newPixelCapiToken = value;
          // Same bookkeeping a paste would do: the id + token pair changed, so
          // any previous verdict from Meta no longer applies to it.
          this.onManualPixelFieldChange();
        },
        () => {
          this.revealingToken = false;
          this.pixelDialogError = this.utils.translate(
            'Could not load the saved access token.'
          );
        }
      );
  }

  /**
   * Whether this edit is about to orphan a stored token.
   *
   * Drives the warning in the dialog: the operator is renaming a pixel whose
   * token cannot follow it, because the stored value is write-only and never
   * reaches the browser.
   */
  get editRenamesPixelWithToken(): boolean {
    const id = (this.newPixelId || '').trim();
    return (
      this.pixelEditIndex !== null &&
      this.pixelOriginalId !== '' &&
      id !== this.pixelOriginalId &&
      !!this.capiTokenSet[this.pixelOriginalId]
    );
  }

  /**
   * Remove a stored CAPI token, without touching the pixel list.
   *
   * Used when a pixel is renamed: persistPixelToken() writes the NEW id, this
   * clears the one left behind. Failure is reported but does not block the
   * save -- the pixel list is already written by this point, and a stranded
   * token is an operator problem rather than a broken storefront.
   */
  clearPixelToken(pixelId: string) {
    this.svc
      .updatePixelCapiToken(this.bearer, {
        store_id: this.store.store_id,
        pixel_id: pixelId,
        token: '',
      })
      .subscribe(
        () => {
          const next = { ...this.capiTokenSet };
          delete next[pixelId];
          this.capiTokenSet = next;
        },
        () => {
          this.utils.notify.showError(
            this.utils.translate(
              'The pixel was saved, but the access token stored under the old Pixel ID could not be removed.'
            ),
            'Conversions API'
          );
        }
      );
  }

  /**
   * Write one pixel's CAPI token, or clear it.
   *
   * Skipped when the operator left a stored token untouched: sending a blank
   * token would clear it.
   */
  persistPixelToken(pixelId: string, token: string) {
    const clearing = this.newPixelCapiSource !== 'manual';
    if (!clearing && token === '') {
      // Manual, blank input, token already stored: keep what is saved.
      this.capiTokenSet = { ...this.capiTokenSet, [pixelId]: true };
      return;
    }

    const body = {
      store_id: this.store.store_id,
      pixel_id: pixelId,
      token: clearing ? '' : token,
    };
    this.svc.updatePixelCapiToken(this.bearer, body).subscribe(
      () => {
        const next = { ...this.capiTokenSet };
        if (clearing) {
          delete next[pixelId];
        } else {
          next[pixelId] = true;
        }
        this.capiTokenSet = next;
        this.getAllStoreConfig();
      },
      () => {
        this.utils.notify.showError(
          this.utils.translate('Update Failed!'),
          'Conversions API'
        );
      }
    );
  }

  removePixel(index: number) {
    const pixel = this.facebookPixels[index];
    if (!pixel) {
      return;
    }
    this.utils.msgBox.open({
      message: this.utils.translate(
        'Are you sure you want to remove this Pixel ID?'
      ) + `\n${pixel.pixel_id}`,
      title: this.utils.translate('Remove Pixel ID?'),
      icon: 'warning',
      contentClassList: 'whitespace-pre-line',
      buttonList: [
        {
          text: this.utils.translate('Cancel'),
        },
        {
          text: this.utils.translate('Remove'),
          style: 'danger',
          onClick: () => {
            const list = this.facebookPixels.filter((p, i) => i !== index);
            // Drop the token too, so a re-added pixel with the same id does
            // not silently inherit the old one.
            this.persistPixels(list, undefined, () => {
              if (this.capiTokenSet[pixel.pixel_id]) {
                this.svc
                  .updatePixelCapiToken(this.bearer, {
                    store_id: this.store.store_id,
                    pixel_id: pixel.pixel_id,
                    token: '',
                  })
                  .subscribe(
                    () => {
                      const next = { ...this.capiTokenSet };
                      delete next[pixel.pixel_id];
                      this.capiTokenSet = next;
                    },
                    () => {}
                  );
              }
            });
          },
        },
      ],
    });
  }

  persistPixels(list: FacebookPixel[], modal?, onSaved?: () => void) {
    if (this.pixelSaving) {
      return;
    }
    const me = this;
    const body = {
      store_id: me.store.store_id,
      name: 'facebook_pixel',
      value: list.length ? JSON.stringify(list) : 0,
    };
    me.pixelSaving = true;
    me.svc.updateConfig(me.bearer, body).subscribe(
      (res) => {
        me.pixelSaving = false;
        me.facebookPixels = list;
        if (modal) {
          modal.close('saved');
        }
        if (onSaved) {
          onSaved();
        }
        me.getAllStoreConfig();
        me.utils.notify.showSuccess(
          me.utils.translate('Updated Successfully!'),
          'Facebook Pixel'
        );
      },
      (error) => {
        me.pixelSaving = false;
        me.utils.notify.showError(
          me.utils.translate('Update Failed!'),
          'Facebook Pixel'
        );
      }
    );
  }

  editForm(form: number, edit = true) {
    (this as any)[`edit${form}`] = edit;
    if (!edit) {
      switch (form) {
        case 1:
        case 2:
        case 3:
          this.analyticsForm = this.formBuilder.group({
            google_analytics_id: [this.google_analytics_id],
            tiktok_pixel_id: [this.tiktok_pixel_id],
          });
          break;
        case 4:
          this.globalSEOForm = this.formBuilder.group({
            description: [this.description],
            keywords: [this.keywords],
            page_title: [this.page_title],
          });
          this.isDisableSave = false;
          break;
        case 5:
          this.socialMediaForm = this.formBuilder.group({
            twitter: this.twitter,
            website: this.website,
            youtube: this.youtube,
            facebook: this.facebook,
            instagram: this.instagram,
            wechat: this.wechat,
            tiktok: this.tiktok,
          });
          break;
        case 6:
          this.messengerForm = this.formBuilder.group({
            whatsapp_flag: [this.whatsapp_flag],
            whatsapp_number: [this.whatsapp_number],
            line_messenger: [this.line_messenger],
          });
          break;
        case 7:
          this.checkoutPage = this.formBuilder.group({
            whatsapp_number_thank_you_page: [this.whatsapp_number_thank_you_page],
          });
          break;
      }
    }
  }

  numericOnly(event): boolean {
    // restrict e,+,-,E characters in  input type number
    const charCode = event.which ? event.which : event.keyCode;
    if (
      charCode == 101 ||
      charCode == 69 ||
      charCode == 45 ||
      charCode == 46 ||
      charCode == 43
    ) {
      return false;
    }
    return true;
  }

  toggleConfig(configType, status) {
    let configName = '';
    let message = '';

    status = status ? 0 : 1;

    switch (configType) {
      case 1:
        configName = 'language_config';
        message = 'Store Language';
        this.isShowLanguageSetting = status;
        break;
      case 2:
        configName = 'country_config';
        message = 'Store Country';
        this.isShowCountrySetting = status;
        break;
      case 'cod':
        configName = 'auto_approve_cod';
        message = 'Auto Approve COD';
        break;
      case 'self_collect':
        configName = 'auto_approve_collect';
        message = 'Auto Approve Self Collect';
        break;
    }

    // Auto-approve is set per store country.
    if (this.autoApproveConfigName(configType) && this.paymentCountryCode) {
      this.updateCountryConfig(configName, this.autoApproveByCountry[configName], message, status);
      return;
    }

    this.updateDealerConfig(configName, message, status);
  }

  // True when `type` is the only payment method still enabled for the
  // selected country, so its switch must not be turned off.
  checkPaymentMethod(type) {
    const enabledTypes = ['cod', 'self_collect', 'installment', 'non_cod'].filter((t) =>
      this.getDealerPaymentMethod(t)
    );
    return enabledTypes.length === 1 && enabledTypes[0] === type;
  }

  togglePayment(type, status) {
    let message = '';
    status = status ? 0 : 1;

    let check = this.checkPaymentMethod(type);

    if (check) {
      // return warning
      this.utils.notify.showWarning(
        this.utils.translate('Something went wrong! please contact support.'),
        this.utils.translate('Uh oh!')
      );
    } else {
      switch (type) {
        case 'non_cod':
          message = 'Online Banking, Credit Card, or E-Wallet';
          break;

        case 'cod':
          message = 'Cash On Delivery';
          break;

        case 'self_collect':
          message = 'Self Collect';
          break;

        case 'installment':
          message = 'Installment';
          break;

        case 'subscription':
          message = 'Subscription';
          break;
      }

      message =
        this.utils.translate('Payment Method') +
        ' : ' +
        this.utils.translate(message);

      // The Enabled switch is set per store country.
      if (this.paymentCountryCode) {
        this.updateCountryConfig(type, this.paymentEnabledByCountry[type], message, status);
        return;
      }
      this.updateDealerConfig(type, message, status);
    }
  }

  updateDealerConfig(configName, message, status) {
    let body = {
      store_id: this.store.store_id,
      name: configName,
      value: status,
    };

    this.svc.updateConfig(this.bearer, body).subscribe(
      (res) => {
        this.getAllStoreConfig();
        this.utils.notify.showSuccess(
          this.utils.translate('Updated Successfully!'),
          this.utils.translate(message)
        );
      },
      (error) => {
        this.utils.notify.showError(
          this.utils.translate('Update Failed!'),
          this.utils.translate(message)
        );
      }
    );
  }

  updateSeoForm() {
    const defaultLangSelect = this.globalSeo[this.selectedSeoLanguageCode];
    if (defaultLangSelect != undefined) {
      this.globalSEOForm = this.formBuilder.group({
        description: [defaultLangSelect.description],
        keywords: [defaultLangSelect.keywords],
        page_title: [defaultLangSelect.page_title],
      });
      this.description = defaultLangSelect.description;
      this.keywords = defaultLangSelect.keywords;
      this.page_title = defaultLangSelect.page_title;
      this.globalSEOForm.controls['description'].setValue(
        defaultLangSelect.description
      );
      this.globalSEOForm.controls['page_title'].setValue(
        defaultLangSelect.page_title
      );
      this.globalSEOForm.controls['keywords'].setValue(
        defaultLangSelect.keywords
      );
    } else {
      this.globalSEOForm = this.formBuilder.group({
        description: [''],
        keywords: [''],
        page_title: [''],
      });
    }
  }

  changeLangauge(languageCode, languageName) {
    this.selectedSeoLanguageCode = languageCode;
    this.language_name = languageName;
    this.updateSeoForm();
  }

  favIcoChanged(event) {
    this.updateConfig(11, {
      store_id: this.store.store_id,
      name: 'favicon_img',
      value: event?.url,
    });
  }

  ogImgChanged(event) {
    this.updateConfig(12, {
      store_id: this.store.store_id,
      name: 'og_img',
      value: event?.url,
    });
  }

  /* Store Logo ------------------------------------------------------------ */

  storeLogoChanged(event) {
    // Unlike the favicon, nothing is written until Save — the logo is part of
    // the theme's custom content record, which has to be read and merged first.
    this.storeLogoUrl = event?.url ?? '';
    this.storeLogoMediaId = event?.mediaId ?? '';
  }

  get storeLogoLanguages() {
    return (this.language ?? []).filter((lang) => +lang.status);
  }

  changeStoreLogoLanguage(languageCode, languageName) {
    if (languageCode === this.storeLogoLanguageCode) return;

    this.storeLogoLanguageCode = languageCode;
    this.storeLogoLanguageName = languageName;

    // Discards any unsaved edit — the card always shows what is stored for the
    // language on screen, so a Save can never write a value from another one.
    this.getStoreLogo();
  }

  getStoreLogo() {
    const theme_id = this.store?.theme_id;
    if (!theme_id) return;

    if (!this.storeLogoLanguageCode) {
      const defaultLanguage = this.getDefaultLanguage();
      this.storeLogoLanguageCode = defaultLanguage?.language_code ?? 'en-US';
      this.storeLogoLanguageName =
        defaultLanguage?.language_name ?? this.storeLogoLanguageCode;
    }

    this.storeLogoIsLoading = true;

    this.svc
      .getCustomContent(
        this.store_id,
        this.storeLogoLanguageCode,
        theme_id,
        this.bearer
      )
      .subscribe(
        (res: any) => {
          const content = this.parseCustomContent(res?.data?.content);

          this.storeLogoUrl = content['store_logo_url'] ?? '';
          this.storeLogoWidth =
            +content['store_logo_width'] || this.STORE_LOGO_DEFAULT_WIDTH;
          this.storeLogoHeight =
            +content['store_logo_height'] || this.STORE_LOGO_DEFAULT_HEIGHT;

          this.storeLogoIsLoading = false;
        },
        () => {
          this.storeLogoIsLoading = false;
          this.utils.notify.showError(
            this.utils.translate('Failed to load the store logo.')
          );
        }
      );
  }

  saveStoreLogo() {
    const theme_id = this.store?.theme_id;
    if (!theme_id) return;

    // Custom content is stored per language with no cross-language fallback, so
    // "apply to all" has to patch every enabled language one by one — otherwise
    // a shopper switching language would still see the old logo.
    let languageCodes = this.storeLogoApplyAllLanguages
      ? this.storeLogoLanguages.map((lang) => lang.language_code)
      : [this.storeLogoLanguageCode];

    languageCodes = languageCodes.filter(Boolean);

    if (!languageCodes.length) languageCodes = [this.getDefaultLanguageCode()];

    this.storeLogoIsSaving = true;

    let presetDesign = {};

    this.svc
      .getSchema(theme_id, this.bearer)
      .pipe(
        switchMap((schemaRes: any) => {
          presetDesign = this.parseCustomContent(
            schemaRes?.data?.preset_design_data
          );

          return forkJoin(
            languageCodes.map((code) =>
              this.svc.getCustomContent(
                this.store_id,
                code,
                theme_id,
                this.bearer
              )
            )
          );
        }),
        switchMap((responses: any[]) =>
          forkJoin(
            responses.map((res, index) =>
              this.svc.updateCustomContent(
                this.buildStoreLogoPayload(
                  theme_id,
                  languageCodes[index],
                  this.parseCustomContent(res?.data?.content),
                  presetDesign
                ),
                this.bearer
              )
            )
          )
        )
      )
      .subscribe(
        () => {
          this.storeLogoIsSaving = false;
          this.utils.notify.showSuccess(
            this.utils.translate('Updated Successfully!')
          );
        },
        () => {
          this.storeLogoIsSaving = false;
          this.utils.notify.showError(this.utils.translate('Update failed!'));
        }
      );
  }

  // custom_content/update replaces the whole record, split into content and
  // design. Which bucket a key belongs to is decided by the theme preset's
  // design data — the same rule the Site Editor's Publish applies. Sending an
  // empty design would overwrite the stored one, so the split is reproduced
  // here rather than posting the logo keys on their own.
  private buildStoreLogoPayload(
    theme_id,
    language_code,
    savedContent,
    presetDesign
  ) {
    const merged = {
      ...savedContent,
      store_logo_url: this.storeLogoUrl ?? '',
      store_logo_width:
        +this.storeLogoWidth || this.STORE_LOGO_DEFAULT_WIDTH,
      store_logo_height:
        +this.storeLogoHeight || this.STORE_LOGO_DEFAULT_HEIGHT,
    };

    const design = {};
    const content = { ...merged };

    Object.keys(presetDesign ?? {}).forEach((key) => {
      if (key in merged) design[key] = merged[key];
      delete content[key];
    });

    return { theme_id, store_id: this.store_id, design, content, language_code };
  }

  private parseCustomContent(raw) {
    try {
      return JSON.parse(raw ?? '{}') ?? {};
    } catch {
      return {};
    }
  }

  private getDefaultLanguage() {
    const languages = this.language ?? [];
    return languages.find((lang) => +lang.default) ?? languages[0];
  }

  private getDefaultLanguageCode() {
    return this.getDefaultLanguage()?.language_code ?? 'en-US';
  }

  toggleOffAll() {
    for (let key in this.collapseStates) {
      this.collapseStates[key] = true;
    }
  }
  toggleOpen(key) {
    const wasOpen = !this.collapseStates[key];
    this.toggleOffAll();
    this.collapseStates[key] = wasOpen;
  }
  selectTab(tab: string) {
    this.selectedTab = tab;

    if (tab === 'Site Identity') this.getStoreLogo();

    this.changeDetectorRef.detectChanges();

    // In AOT builds @ViewChild(static:false) is not updated synchronously
    // after detectChanges() — defer by one tick so the *ngIf content and
    // ViewChild references are fully resolved before mounting CodeMirror.
    setTimeout(() => {
      this.initCodemirror();
      this.initHicommEditor();
      // Remove Monaco Elements
      this.headerScriptEl2?.nativeElement.remove();
      this.bodyScriptEl2?.nativeElement.remove();
      this.footerScriptEl2?.nativeElement.remove();
    }, 0);
  }

  showAIGlobalMetaDesc(presetParams) {
    this.utilitiesService.aiContentGenerator.show(
      'GENERATE_SEO_DESC',
      presetParams,
      (response) => {
        this.description = response;
        this.globalSEOForm.controls['description'].setValue(response);
        this.globalSEOForm.patchValue({ description: response });
        this.isDisableSave = true;
      }
    );
  }

  showAIGlobalMetaKeyword(presetParams) {
    this.utilitiesService.aiContentGenerator.show(
      'GENERATE_SEO_KEYWORD',
      presetParams,
      (response) => {
        this.keywords = response;
        this.globalSEOForm.controls['keywords'].setValue(response);
        this.globalSEOForm.patchValue({ keywords: response });
        this.isDisableSave = true;
      }
    );
  }

  @ViewChild('sitemapPathRef') sitemapPathRef: ElementRef<HTMLInputElement>;

  copySitemap() {
    this.sitemapPathRef.nativeElement.focus();
    const sitemapUrl = `${this.store_url}/sitemap.xml`;
    this.utilitiesService.copyToClipboard(sitemapUrl);
  }

  downloadSitemap() {
    const sitemapDlUrl = `${this.store_url}/download/sitemap`;
    this.utilitiesService.notify.showInfo('Downloading...');
    // redirect to sitemapDlUrl in new tab
    const win = window.open(sitemapDlUrl, '_blank');
    if (win) {
      win.focus();
    } else {
      this.utilitiesService.notify.showWarning(
        'Please allow popups for this site'
      );
    }
  }

  public onCheckoutStepChanged(): void {
    this.isCheckoutStepsChanged = !this.isCheckoutStepsChanged;
  }

  public changeCheckoutSteps(): void {
    this.isCheckoutStepsLoading = true;
    const body = {
      store_id: this.store_id,
      is_single_checkout: this.isCheckoutStepsSingle,
    };

    this.svc.updateCheckoutStepsConfig(this.bearer, body).subscribe(
      (res) => {
        this.isCheckoutStepsLoading = false;
        this.isCheckoutStepsChanged = false;
        this.isCheckoutStepsSingle = Number(
          res?.['data']['is_single_checkout']
        );

        this.utils.notify.showSuccess(
          this.utils.translate('Checkout Steps Update Successfully!')
        );
      },
      (error) => {
        this.isCheckoutStepsLoading = false;
        this.utils.notify.showError(
          this.utils.translate('Checkout Steps Update Failed!')
        );
      }
    );
  }

  globalSEOFormChange() {
    if (
      this.globalSEOForm.value['description'] != this.description ||
      this.globalSEOForm.value['page_title'] != this.page_title ||
      this.globalSEOForm.value['keywords'] != this.keywords
    ) {
      this.isDisableSave = true;
    } else {
      this.isDisableSave = false;
    }
  }

  public toggleTestimonial(event: any): void {
    this.testimonialToggle = event.target.checked;
    if(this.testimonialToggle){
      this.testimonialGet = "true";
    }else{
      this.testimonialGet = "false";
    }
    const body = {
      name: 'testimonial',
      store_id: this.store_id,
      value: this.testimonialGet
    };

    this.svc.updateConfig(this.bearer, body).subscribe(
      (res) => {
        this.isCheckoutStepsLoading = false;
        this.utils.notify.showSuccess(
          this.utils.translate('Testimonial Settings Updated Successfully!')
        );
      },
      (error) => {
        this.isCheckoutStepsLoading = false;
        event.target.checked = !event.target.checked;
        this.utils.notify.showError(
          this.utils.translate('Failed to Update Testimonial Settings')
        );
      }
    );
  }


  get defaultCountryCode(): string {
    const defaultCountry = this.countryList.find((c: any) => c.default == '1');
    return defaultCountry?.country_code ?? '';
  }

  // Countries switched on in Regional Settings, one entry per code
  // (store_dealer_country can repeat a code and has blank-code rows).
  buildPaymentCountryList(list: any[]): any[] {
    const seen = new Set<string>();
    return (list || []).filter((c: any) => {
      const code = (c?.country_code || '').trim();
      if (!code || String(c.status) !== '1' || seen.has(code)) return false;
      seen.add(code);
      return true;
    });
  }

  // Keep the selector on a country that is still enabled: the default
  // country first, otherwise the first enabled one.
  syncPaymentCountrySelection() {
    const codes = this.paymentCountryList.map((c: any) => c.country_code);
    if (!codes.includes(this.paymentCountryCode)) {
      this.paymentCountryCode = codes.includes(this.defaultCountryCode)
        ? this.defaultCountryCode
        : codes[0] ?? '';
    }
    this.ensureCourierSelection();
  }

  onPaymentCountryChange(code: string) {
    this.paymentCountryCode = code;
    this.ensureCourierSelection();
  }

  paymentCountryLabel(country: any): string {
    const name = country?.country_name_full || country?.country_name || '';
    return `${name} (${country?.country_code})`;
  }

  /**
   * A payment method that is switched on must offer at least one courier in
   * the selected country, or checkout there has nothing to ship with. When a
   * country comes up with none ticked, tick its first courier and flag the
   * card as changed so the dealer saves it. Runs whenever any of the three
   * inputs (countries, payment methods, payment toggles) load or change.
   */
  ensureCourierSelection() {
    if (!this.paymentCountryCode) return;

    let ticked = false;
    (this.paymentMethod ?? [])
      .filter(
        (m: any) =>
          ['non_cod', 'cod'].includes(m.type) &&
          this.getDealerPaymentMethod(m.type)
      )
      .forEach((method: any) => {
        const couriers = this.getCourierOptions(method);
        if (couriers.length === 0 || this.getEnabledCourierCount(couriers) > 0) {
          return;
        }
        couriers[0].enabled = true;
        this.courierChangedMap[method.type] = true;
        if (method.type === 'non_cod') {
          this.syncCouriersToInstallment();
        }
        ticked = true;
      });

    // Only announce it while the dealer is looking at the Payments tab; on
    // the other tabs the lit Save button is explanation enough later.
    if (ticked && this.selectedTab === 'Payments') {
      this.utils.notify.showInfo(
        this.utils.translate(
          'No courier was selected for this country, so the first courier has been ticked. Save to keep this change.'
        )
      );
    }
  }

  getCourierOptions(
    paymentData: any,
    countryCode: string = this.paymentCountryCode || this.defaultCountryCode
  ): any[] {
    const couriers: any[] = paymentData?.courier_options ?? [];
    return couriers.filter((c) =>
      c.disabled !== '1' &&
      (!countryCode || c.country_code === countryCode)
    );
  }

  isAllCouriersEnabled(courierOptions: any[]): boolean {
    return courierOptions.length > 0 && courierOptions.every((c) => c.enabled);
  }

  getEnabledCourierCount(courierOptions: any[]): number {
    return courierOptions.filter((c) => c.enabled).length;
  }

  toggleAllCouriers(enabled: boolean, courierOptions: any[], type: string) {
    courierOptions.forEach((c) => (c.enabled = enabled));
    this.courierChangedMap[type] = true;
    if (type === 'non_cod') {
      this.syncCouriersToInstallment();
    }
  }

  dropCourier(event: CdkDragDrop<any[]>, method: any) {
    const couriers = this.getCourierOptions(method);
    const sourceIdx = method.courier_options.indexOf(couriers[event.previousIndex]);
    const targetIdx = method.courier_options.indexOf(couriers[event.currentIndex]);
    if (sourceIdx !== -1 && targetIdx !== -1) {
      moveItemInArray(method.courier_options, sourceIdx, targetIdx);
      this.courierChangedMap[method.type] = true;
      if (method.type === 'non_cod') {
        this.syncCouriersToInstallment();
      }
    }
  }

  toggleCourier(courier: any, type: string) {
    courier.enabled = !courier.enabled;
    this.courierChangedMap[type] = true;
    if (type === 'non_cod') {
      this.syncCouriersToInstallment();
    }
  }

  /**
   * Mirror the enabled state of non_cod couriers onto the installment couriers.
   * Called whenever non_cod courier selections change and on initial load.
   * Covers every country (not just the selected one) so the installment card
   * is already in step when the country selector moves.
   */
  syncCouriersToInstallment() {
    const nonCodMethod = (this.paymentMethod ?? []).find((m: any) => m.type === 'non_cod');
    const installmentMethod = (this.paymentMethod ?? []).find((m: any) => m.type === 'installment');
    if (!nonCodMethod || !installmentMethod) return;

    const nonCodCouriers = this.getCourierOptions(nonCodMethod, '');
    const installmentCouriers = this.getCourierOptions(installmentMethod, '');

    installmentCouriers.forEach((instCourier: any) => {
      const matched = nonCodCouriers.find(
        (c: any) =>
          c.courier_code === instCourier.courier_code &&
          c.country_code === instCourier.country_code
      );
      if (matched !== undefined) {
        instCourier.enabled = matched.enabled;
      }
    });
  }

  saveCourierPreferences(type: string, courierOptions: any[]) {
    // The saved list covers every store country, so each enabled country
    // needs at least one courier, not just the one on screen. When another
    // country is the empty one, switch the selector to it so the warning
    // points at the list that needs a tick.
    const method = (this.paymentMethod ?? []).find((m: any) => m.type === type);
    const emptyCountry = this.paymentCountryList.find((c: any) => {
      const list = this.getCourierOptions(method, c.country_code);
      return list.length > 0 && this.getEnabledCourierCount(list) === 0;
    });
    if (this.getEnabledCourierCount(courierOptions) < 1 || emptyCountry) {
      if (emptyCountry) {
        this.paymentCountryCode = emptyCountry.country_code;
      }
      this.utils.notify.showWarning(
        this.utils.translate('Please select at least 1 courier service before saving.'),
        this.utils.translate('Insufficient Couriers Selected')
      );
      return;
    }

    // Build combined payload — exclude self_collect and installment.
    // Installment inherits non_cod courier list server-side. The list is
    // cross-country (the storefront filters by country_code at checkout), so
    // every country's enabled couriers go in, not only the selected one —
    // otherwise saving from one country would wipe the others.
    const allCourierOptions = (this.paymentMethod ?? [])
      .filter((method: any) => method.type !== 'self_collect' && method.type !== 'installment')
      .map((method: any) => ({
        type: method.type,
        list: (method.courier_options ?? [])
          .filter((c: any) => c.disabled !== '1' && c.enabled)
          .map((c: any) => c.courier_code),
      }));

    this.courierIsSavingMap[type] = true;

    const body = {
      store_id: this.store.store_id,
      name: 'courier_options',
      value: JSON.stringify(allCourierOptions),
    };

    this.svc.updateConfig(this.bearer, body).subscribe(
      () => {
        this.courierIsSavingMap[type] = false;
        // Reset changed state for all types
        Object.keys(this.courierChangedMap).forEach((k) => (this.courierChangedMap[k] = false));
        this.utils.notify.showSuccess(
          this.utils.translate('Courier preferences saved successfully!')
        );
      },
      () => {
        this.courierIsSavingMap[type] = false;
        this.utils.notify.showError(
          this.utils.translate('Failed to save courier preferences.')
        );
      }
    );
  }

  saveLoadingIconSettings(styleLabels) {
    if (this.isLoadingIconSaving) return; // Prevent multiple clicks
    
    this.isLoadingIconSaving = true;
    const body = {
      name: 'storeLoading',
      store_id: this.store_id,
      value: styleLabels
    };

    this.svc.updateConfig(this.bearer, body).subscribe(
      (res) => {
        this.utils.notify.showSuccess(
          this.utils.translate('Loading Icon Settings Updated Successfully!')
        );
        this.isLoadingIconSaving = false;
      },
      (error) => {
        this.utils.notify.showError(
          this.utils.translate('Failed to Update Loading Icon Settings')
        );
        this.isLoadingIconSaving = false;
      }
    );
  }
}
